export default {
  "t-menu": "меню",
  "t-device-trend-chart": "График тенденции устройства",
  "t-dashboard": "Панель управления",
  "t-search": "поиск",
  "t-reset": "сбросить",
  "t-default": "по умолчанию",
  "t-system": "система",
  "t-system-param": "Системный параметр",
  "t-normal": "нормальный",
  "t-suspend": "приостановка",
  "t-create": "добавлять",
  "t-edit": "редактировать",
  "t-copy": "копировать",
  "t-export": "экспорт",
  "t-download": "скачать",
  "t-install": "установка",
  "t-clean": "очистить",
  "t-enter": "ввод",
  "t-select": "выбор",
  "t-selected": "выбрано",
  "t-next": "следующий шаг",
  "t-submit": "представить",
  "t-update": "обновление",
  "t-cancel": "отменить",
  "t-cancel-reset": "сбросить и отменить",
  "t-name": "название",
  "t-alias": "псевдоним",
  "t-value": "значение",
  "t-from": "от",
  "t-user-name": "имя пользователя",
  "t-current": "текущий",
  "t-new": "новый",
  "t-password": "пароль",
  "t-confirm-password": "Подтвердить пароль",
  "t-length": "длина",
  "t-type": "тип",
  "t-check": "проверка",
  "t-radius": "радиус",
  "t-refresh": "обновлять",
  "t-delete": "удалить",
  "t-import": "импорт",
  "t-confirm": "подтвердить",
  "t-confirm-to": "Вы уверены",
  "t-confirm-delete": "Вы уверены, что хотите удалить - {param}",
  "t-confirm-clean-logs": "Вы уверены, что хотите удалить журналы?",
  "t-detail": "подробности",
  "t-usage": "использование",
  "t-records": "подробности",
  "t-location": "положение",
  "t-add": "добавлять",
  "t-size": "размер",
  "t-website": "веб-сайт",
  "t-address": "адрес",
  "t-remark": "Примечание",
  "t-description": "описание",
  "t-phone": "телефон",
  "t-phone-number": "телефон",
  "t-file": "файл",
  "t-icon": "иконка",
  "t-status": "состояние",
  "t-action": "операция",
  "t-code": "код",
  "t-revoke": "отменить",
  "t-create-by": "создатель",
  "t-create-time": "время создания",
  "t-executed-at": "Время выполнения",
  "t-execution-time": "время выполнения",
  "t-execute-by": "Исполнитель",
  "t-expiration-time": "время истечения срока действия",
  "t-modified-by": "Изменено",
  "t-modified-time": "дата изменения",
  "t-last-update-by": "Последний обновивший",
  "t-last-update-time": "Дата последнего обновления",
  "t-date": "дата",
  "t-seconds": "секунда",
  "t-minute": "минута",
  "t-hour": "час",
  "t-day": "день",
  "t-day-number": "rd",
  "t-month": "месяц",
  "t-week": "неделя",
  "t-region": "регион",
  "t-continent": "континент",
  "t-basic": "классическая версия",
  "t-premium": "Премиум-версия",
  "t-switch": "переключение",
  "t-quantity": "количество",
  "t-success": "успех",
  "t-fail": "неудача",
  "t-pending": "в процессе",
  "t-reverted": "восстановлено",
  "t-yes": "да",
  "t-no": "нет",
  "t-login": "Вход",
  "t-logout": "Выход",
  "t-last-online-time": "Время последнего выхода в сеть",
  "t-last-updated-time": "Время последнего обновления данных",
  "t-back": "возврат",
  "t-duration": "продолжительность",
  "t-click-check": "нажмите, чтобы просмотреть",
  "t-aborted": "прервано",
  "t-terminal-supported-functions": "Тип терминала",
  "t-format": "формат",
  "t-disable-signature": "Отключить подпись",
  "t-polygon": "многоугольник",
  "t-radius-in-meters": "Радиус [50-9999]метров",
  "t-radius-in-hours": "Продолжительность [0-72]часа",
  "t-duration-value-range": "Диапазон продолжительности: 0-72 часа",
  "t-radius-value-range": "Диапазон радиуса: 50-9999 метров",
  "t-loading": "Загрузка...",
  "t-image": "картинка",
  "t-video": "Аудио",
  "t-text": "текст",
  "t-html": "HTML",
  "t-required": "Это обязательное поле",
  "t-remove": "удалить",
  "t-logo": "Знак",
  "t-partner-portal-logo": "Логотип портала партнеров",
  "t-notfound-result": "Извините! Результатов не найдено",
  "t-set": "установка",
  "t-number": "количество",
  "t-login-as-partner": "Войти как партнер",
  "t-logout-as-partner": "Выйти из системы как партнер",
  "t-abnormal-devices": "Аномальные устройства",
  "t-abnormal-device-status": "Аномальный статус устройства",
  "t-last-7-days": "Последние 7 дней",
  "t-last-14-days": "Последние 14 дней",
  "t-last-30-days": "Последние 30 дней",
  "t-last-90-days": "Последние 90 дней",
  "t-last-365-days": "Последние 365 дней",
  "t-last-days-number": "Последние {param} дней",
  "t-table": "таблица",
  "t-head": "заголовок",
  "t-open": "открыть",
  "t-close": "закрыть",
  "t-notification": "уведомление",
  "t-public": "публичный",
  "t-welcome-back": "Добро пожаловать обратно",
  "t-sign-in-continue-storm": "Продолжить STORM для входа",
  "t-remember-me": "Помните меня",
  "t-sign-in": "Вход",
  "t-please-wait": "Вход в систему",
  "t-storm-introduction-title1": "Система дистанционного управления и управления интеллектуальными терминалами",
  "t-storm-introduction-title2": "Feitian разработала следующее поколение платформы управления TMS, а именно платформу “STORM” ",
  "t-storm-introduction-title3": "Включает такие функции, как служба отправки сообщений, дистанционная инъекция ключей, дистанционное обновление OTA, дистанционное управление терминальным оборудованием и т. д.",
  "t-login-status-expired": "Время входа истекло. Просим вас снова войти в систему!",
  "t-tooltip-device": "Номер устройства, TID, MID, IMEI",
  "t-sn": "Номер устройства",
  "t-terminal-management-system": "Система управления терминалами",
  "t-device-mgmt": "Управление оборудованием",
  "t-uninstall": "удалить",
  "t-uninstall-block": "Запрет на удаление",
  "t-device": "устройство",
  "t-ecr-pos": "ECR POS",
  "t-serial-number": "Серийный номер",
  "t-product-bundle": "Комплект продуктов",
  "t-device-detail": "Подробная информация об оборудовании",
  "t-charts-devices": "устройство",
  "t-charts-push-report": "Запись о рассылке",
  "t-bind": "связать",
  "t-bind-to": "привязать к",
  "t-unbind": "отвязка",
  "t-device-secret": "секрет устройства",
  "t-product-key": "Продуктовый ключ",
  "t-available": "доступно",
  "t-used": "использовано",
  "t-current-version-deleted": "Удалено",
  "t-available-list": "Доступные устройства",
  "t-bound-list": "Уже привязанные устройства",
  "t-selected-list": "Выбранное оборудование",
  "t-select-device-bind": "Выберите устройство для связки",
  "t-batch": "партия",
  "t-upload": "загрузка",
  "t-refresh-device": "обновление устройства",
  "t-remote-control": "Дистанционное управление",
  "t-remote-control-auto-pwd": "Дистанционное управление (автоматический пароль)",
  "t-disable-remote-control": "Отключение RC",
  "t-device-not-partner": "Устройство не привязано к партнеру",
  "t-remote-control-failed": "Не удалось осуществить дистанционное управление. Пожалуйста, сначала отключите режим полноэкранного отображения",
  "t-remote-control-steps": "При подключении устройства для удаленного управления... ",
  "t-disable-device": "Отключить устройство",
  "t-out-of-fence": "За пределами геозоны",
  "t-active-statistics": "Активационная статистика",
  "t-online-statistics": "Онлайн-статистика",
  "t-active": "активировать",
  "t-inactive": "не активирован",
  "t-out-of-country": "За пределами национальной территории",
  "t-under-activation": "подлежит активации",
  "t-online": "онлайн",
  "t-offline": "оффлайн",
  "t-block": "Разборка устройства",
  "t-device-disabled": "устройство отключено",
  "t-device-disabled-tamper": "Устройство отключено, вскрытие корпуса",
  "t-device-tamper-no": "Устройство в норме",
  "t-device-tamper-yes": "Устройство было вскрыто",
  "t-filters": "Продвинутый запрос",
  "t-basic-information": "Базовая информация",
  "t-installed-application": "Приложения, установленные на устройстве",
  "t-last-factory-settings-time": "Время последнего сброса к заводским настройкам",
  "t-timeline": "Записи о задачах на рассылку",
  "t-android": "Android",
  "t-build-number": "Системная версия",
  "t-sp-bootloader": "SP загрузчик",
  "t-sma-version-code": "Версия SMA",
  "t-version-code": "код версии",
  "t-version-type": "Тип версии",
  "t-sma-status": "Статус SMA",
  "t-pubkey-status": "Статус открытого ключа",
  "t-cortex-scanner": "Сканер Cortex",
  "t-total": "общий итог",
  "t-cpu-statistics": "Статистика CPU",
  "t-ram-statistics": "Статистика ОЗУ",
  "t-storage-statistics": "статистика хранения",
  "t-authorisations": "Авторизация",
  "t-kiosk-mode": "Режим полноэкранного отображения",
  "t-set-kiosk-mode": "Установить режим полноэкранного отображения",
  "t-cancel-kiosk-mode": "Отменить режим Kiosk",
  "t-screen-resolution": "Разрешение экрана",
  "t-battery-capacity": "Емкость батареи",
  "t-sim-number": "Номер SIM-карты",
  "t-sp-firmware": "СП-fw",
  "t-cpu": "Процессор ",
  "t-iccid": "ICCID - (SIM)",
  "t-production-batch": "Производственная партия",
  "t-category": "категория",
  "t-sales-batch": "Партия продаж",
  "t-network": "сеть",
  "t-router-address": "Адрес маршрутизатора",
  "t-router-name": "Название маршрутизатора",
  "t-communication-type": "Тип связи",
  "t-signal-strength": "сигнальная сила",
  "t-transmission-speed": "Скорость передачи",
  "t-wifi": "WIFI",
  "t-mobile": "Мобильный",
  "t-wifi-mac-address": "MAC-адрес WIFI",
  "t-push-mgmt": "Управление рассылкой",
  "t-rki-mgmt": "Управление секретными ключами",
  "t-partner": "партнер",
  "t-parent": "Родительский партнер",
  "t-continent-region-exist": "Данные о том же континенте и регионе уже существуют. Пожалуйста, удалите существующие данные и затем добавьте заново",
  "t-customer": "клиент",
  "t-merchant": "торговец",
  "t-store": "магазин",
  "t-excel-sample-file": "Примерный файл Excel",
  "t-import-strip": "полоса",
  "t-number-of-successes": "количество успехов",
  "t-number-of-failed": "количество неудач",
  "t-import-failed-file": "Файл импорта не удался (нажмите для загрузки)",
  "t-device-settings": "настройки устройства",
  "t-manufacturer": "поставщик оборудования",
  "t-model": "тип оборудования",
  "t-model-version": "версия модели",
  "t-general": "Общий вариант",
  "t-beta": "Грей-версия",
  "t-resolution": "разрешение",
  "t-connection-type": "тип соединения",
  "t-message-protocol": "протокол сообщений",
  "t-hardware-parameter": "параметры оборудования ",
  "t-version": "версия",
  "t-version-list": "Номер версии",
  "t-json-layout": "Формат JSON",
  "t-general-parameter": "Общие параметры системы",
  "t-terminal-profiles": "Профили инициализации терминала ",
  "t-force-initialization": "Принудительная инициализация",
  "t-group": "Группировка оборудования",
  "t-add-device-to-group": "Добавить устройство в группу",
  "t-upload-file-bind-device": "Загрузка файлов и массовая привязка/отвязка устройств",
  "t-geo-fence": "географический забор",
  "t-erase-drawing": "Удалить рисунок",
  "t-log-capture": "захват журнала",
  "t-log": "журнал",
  "t-firmware": "прошивка",
  "t-firmware-version": "версия прошивки",
  "t-md5": "MD5",
  "t-application-mgmt": "Управление приложениями",
  "t-application": "приложение",
  "t-application-name": "название приложения",
  "t-application-version": "версия приложения",
  "t-application-certificates": "сертификаты приложений ",
  "t-certificates": "сертификаты",
  "t-certificate-level": "уровень сертификата",
  "t-tls-certificates": "TLS-сертификаты",
  "t-certificate-version": "Версия сертификата",
  "t-certificate-owner": "Владелец сертификата",
  "t-certificate-issuer": "Выдающий сертификат",
  "t-certificate-serial-number": "серийный номер сертификата",
  "t-certificate-effective-date": "Дата вступления в силу сертификата",
  "t-certificate-expiration-date": "Дата истечения срока действия сертификата",
  "t-certificate-signing-algorithm": "Алгоритм подписания Сертификата",
  "t-batch-upload": "массовая загрузка",
  "t-friendly-name": "Название сертификата",
  "t-name-common": "Общее название",
  "t-country": "страна",
  "t-currency": "валюта",
  "t-city": "город",
  "t-org-unit": "организационная единица",
  "t-org": "организация",
  "t-state-province": "штат / провинция",
  "t-key-store-password": "Пароль хранилища ключей",
  "t-calendar": "календарь",
  "t-transaction-param": "Параметр транзакции",
  "t-byte": "байт",
  "t-copy-code": "копировать код",
  "t-offline-data-authentication-was-not-performed": "Авторизация офлайн-данных не была выполнена",
  "t-sda-failed": "Неудача SDA ",
  "t-icc-data-missing": "Потеря данных ICC",
  "t-card-appears-on-terminal-exception-file": "Карта появляется в файле исключения терминала",
  "t-dda-failed": "Неудача DDA ",
  "t-cda-failed": "Неудача CDA ",
  "t-rfu": "РФУ",
  "t-icc-and-terminal-have-different-application": "ICC и терминал имеют разные версии приложений",
  "t-expired-application": "просроченное приложение",
  "t-application-not-yet-effective": "Приложение еще не вступило в силу",
  "t-requested-service-not-allowed-for-card-product": "Запрошенная услуга не разрешена для карточного продукта",
  "t-new-card": "новая карта",
  "t-cardholder-verification-was-not-successful": "Верификация держателя карты не удалась",
  "t-unrecognised-cvm": "Не распознанный CVM ",
  "t-pin-try-limit-exceeded": "Превышен лимит попыток ввода PIN-кода",
  "t-pin-entry-required-and-pin-pad-not-present-or-not-working": "Необходимо ввести PIN, клавиатура PIN отсутствует или не работает",
  "t-pin-entry-required-pin-pad-present-but-pin-was-not-entered": "Требуется ввод PIN-кода, присутствует клавиатура для ввода PIN-кода, но PIN-код не был введен",
  "t-online-pin-entered": "Введён онлайн-PIN",
  "t-transaction-exceeds-floor-limit": "Транзакция превышает нижний предел",
  "t-lower-consecutive-offline-limit-exceeded": "Превышен нижний предел последовательного офлайн",
  "t-upper-consecutive-offline-limit-exceeded": "Превышен верхний предел последовательного офлайн",
  "t-transaction-selected-randomly-for-online-processing": "Транзакция выбрана случайным образом для онлайн-обработки",
  "t-merchant-forced-transaction-online": "Принудительная онлайн-транзакция торговца",
  "t-package": "пакет",
  "t-package-name": "название пакета",
  "t-application-token": "токен приложения",
  "t-client-token": "Токен клиента",
  "t-intent-name": "Название намерения",
  "t-file-name": "имя файла",
  "t-silent-upgrade": "Автоматическое обновление",
  "t-prompt-for-upgrade": "Подсказка о обновлении",
  "t-upgrade-strategy": "стратегия модернизации",
  "t-upgrade": "обновление",
  "t-upgrade-strategy-for-supports-sma": "Стратегия обновления поддерживается только для SMA. Версия SMA 100513 и выше поддерживает эту стратегию обновления",
  "t-allow-use-network-download": "Разрешить использование мобильной сети для скачивания",
  "t-selected-range-not-allowed": "Выбранный интервал времени не должен превышать 18 часов",
  "t-terminal-allow-use-network-download-network": "Выбрав эту опцию, терминал позволит использовать мобильную сеть для загрузки файлов прошивки",
  "t-time-period-upgrade-tip": "Терминал будет автоматически обновляться в указанный период времени. Если терминал отменит это обновление, оно снова начнется в следующем периоде времени.",
  "t-period-of-time": "период времени",
  "t-start-time-and-end-time-cannot-be-same": "Выбранный интервал времени не может быть одинаковым",
  "t-push-to-device-group": "Пushed to device or group",
  "t-push-login-as-partner": "Войдите как партнер, чтобы выполнить эту функцию",
  "t-push-to-device": "Отправить на устройство",
  "t-push-to-group": "Пуш в группу",
  "t-push-report": "Запись о рассылке",
  "t-abort-push": "Отменить отправку",
  "t-not-start": "не начато",
  "t-warning-to-cancel-push": "Вы уверены, что хотите отменить рассылку?",
  "t-scheduler-tasks": "Планирование задач Отправки",
  "t-planned": "план",
  "t-message": "сообщение",
  "t-message-type": "тип сообщения",
  "t-push-message": "Сообщение о плане истекло",
  "t-showing-duration": "продолжительность отображения",
  "t-unlimited": "без ограничений",
  "t-plan-time": "время планирования",
  "t-message-from": "от",
  "t-every": "каждый",
  "t-content": "содержание",
  "t-advertisement": "реклама",
  "t-advertisement-planner": "план рекламной кампании",
  "t-planner": "план",
  "t-push-advertisement-expired": "Advertisement has expired",
  "t-advertisement-file": "ресурсный файл ",
  "t-loop": "цикл",
  "t-ads-start-date": "Дата и время начала рекламы",
  "t-ads-end-date": "Дата и время окончания рекламы",
  "t-more-detail-url": "Больше подробностей URL",
  "t-detail-url": "URL с подробностями",
  "t-folder": "папка",
  "t-key-capture": "генерация секретного ключа",
  "t-key": "секретный ключ",
  "t-index": "индекс",
  "t-algorithm": "алгоритм",
  "t-key-type": "Тип секретного ключа",
  "t-number-keys": "Количество секретных ключей",
  "t-key-group": "Группа секретных ключей",
  "t-key-value": "Значение секретного ключа",
  "t-kcv": "KCV",
  "t-clear-key": "очистить секретный ключ",
  "t-encrypted-key-under": "Зашифрованный ключ",
  "t-key-capture-report": "Отчет о генерации ключа",
  "t-key-injection": "инъекция ключа",
  "t-hsm": "HSM",
  "t-hsm-model": "Модель HSM",
  "t-interface": "интерфейс",
  "t-primary-host": "Адрес хоста",
  "t-primary-port": "Порт хоста",
  "t-secondary-host": "Адрес вспомогательного хоста",
  "t-secondary-port": "Вспомогательный порт хоста",
  "t-lmk-index": "Индекс LMK",
  "t-enable": "Включено ли",
  "t-key-block": "Блок секретного ключа",
  "t-widgets": "плагины",
  "t-settings": "настройки",
  "t-device-locations": "места расположения устройства",
  "t-role-widget-save-successfully": "Настройки отчета успешно сохранены",
  "t-partner-settings": "Параметры партнера",
  "t-opt": "Двухфакторная аутентификация",
  "t-signature": "Подпись APK",
  "t-cloud-messaging": "Облачное сервисное сообщение",
  "t-detamper-auth": "Отмена проверки демонтажа устройства",
  "t-enable-signature-error-partner-not-found": "Невозможно включить вторую подпись, партнер не связан",
  "t-enable-signature-error-2nd-cert-not-found": "Не удалось включить вторую подпись, второй сертификат не найден",
  "t-partner-setting-updated-successfully": "Партнерские настройки успешно обновлены!",
  "t-error-updating-partner-setting": "Произошла ошибка при обновлении настроек партнера",
  "t-error-loading-partner-setting": "Произошла ошибка при загрузке настроек партнера",
  "t-email-settings": "Настройки электронной почты",
  "t-email": "почтовый ящик",
  "t-email-server": "электронная почтовая сервер",
  "t-email-account": "электронный почтовый аккаунт",
  "t-port": "порт",
  "t-ssl": "SSL",
  "t-starttls": "STARTTLS",
  "t-email-sender": "Отправитель электронной почты",
  "t-sms-settings": "Настройки SMS",
  "t-sms": "смс",
  "t-sms-gateway": "Шлюз для SMS",
  "t-sms-settings-sms": "Поставщик услуг SMS",
  "t-sms-settings-signname": "Название подписи",
  "t-access-key-id": "Идентификатор ключа доступа",
  "t-access-key-secret": "Секретный ключ доступа",
  "t-password-policy": "Политика паролей",
  "t-enable-password-policy": "Включить политику паролей",
  "t-enable-password-length-minimum": "Включить минимальную длину пароля",
  "t-password-length": "Диапазон минимальной длины пароля составляет от 4 до 32",
  "t-required-item": "Этот пункт является обязательным для заполнения",
  "t-password-length-minimum": "Минимальное значение - 4",
  "t-password-length-maximum": "Максимальное значение составляет 32",
  "t-password-policy-pattern": "Это значение должно быть целым числом",
  "t-enable-password-part": "Включение способа формирования пароля",
  "t-password-numbers-and-letters-combination": "Пароль должен быть комбинацией цифр и букв",
  "t-password-use-least-one-uppercase-letter": "по крайней мере, используйте одну заглавную букву",
  "t-repeated-characters-not-allowed-to-use": "Запрещено использование повторяющихся символов",
  "t-allows-use-special-characters": "Разрешено использовать специальные символы (кроме пробелов)",
  "t-use-least-one-special-character": "Необходимо использовать хотя бы один специальный символ",
  "t-different-user-name-and-password": "Имя пользователя и пароль должны быть разными",
  "t-whether-to-enable-history-password": "Запретить использование истории паролей или нет",
  "t-use-history-password-number": "Количество исторических паролей, использование которых не допускается",
  "t-use-history-password-number-minimum": "Минимальное значение составляет 3",
  "t-use-history-password-number-maximum": "Максимальное значение составляет 6",
  "t-enable-password-change-frequency": "Включить частоту изменения пароля",
  "t-password-change-frequency": "Частота изменения пароля (дней/1 раз)",
  "t-password-change-frequency-minimum": "Минимальное значение - 1",
  "t-password-change-frequency-maximum": "Максимальное значение составляет 9",
  "t-change-the-password-regular-basis": "Изменять пароль на регулярной основе",
  "t-password-periodically-change": "Периодически изменять пароль (количество дней)",
  "t-password-periodically-minimum": "Минимальное значение составляет 90",
  "t-password-periodically-maximum": "Максимальное значение составляет 365",
  "t-password-configuration-updated-successfully": "Политика паролей успешно обновлена!",
  "t-error-updated-password-configuration": "Не удалось обновить конфигурацию пароля",
  "t-times-task": "Установка задач по расписанию",
  "t-execute-once": "выполнить один раз",
  "t-task-group": "группа задач",
  "t-method": "метод",
  "t-log-information": "Информация журнала",
  "t-cron-expression": "Крон-выражение",
  "t-clean-condition": "Условие очистки",
  "t-concurrent": "конкурентность",
  "t-wrong-strategy": "ошибочная стратегия",
  "t-allow": "разрешать",
  "t-prohibit": "запрещено",
  "t-execute-immediately": "выполнить немедленно",
  "t-next-execution-time": "время следующего выполнения",
  "t-execute": "выполнять",
  "t-cancel-execution": "Отменить выполнение",
  "t-task-scheduler": "Система планировщика задач по времени",
  "t-task-scheduler-logs": "Записи выполнения системных планировщиков задач",
  "t-notice": "Настройки уведомлений",
  "t-alarm-settings": "Настройки уведомлений о тревоге",
  "t-alarm": "Настройки",
  "t-alarm-mgmt": "Управление тревогами",
  "t-already-used": "использовано",
  "t-silence-time": "Время молчания",
  "t-alert-logs": "Журналы тревог",
  "t-logs": "Журнал",
  "t-alert-status-info-untreated": "не обработано",
  "t-alert-status-info-processed": "обработано",
  "t-alert-status-info-closed": "Закрыто",
  "t-alert-status-info-handle": "обрабатывать",
  "t-alert-status-info-close": "Закрыть",
  "t-rule": "правило ",
  "t-alert-policies": "Политики оповещения",
  "t-policies": "Политика",
  "t-alert-level": "уровень тревоги",
  "t-level": "уровень",
  "t-alerts-cycles": "Циклы тревоги",
  "t-alert-channel": "канал оповещения об аварии",
  "t-contacts-group": "Группа контактов",
  "t-contacts-user": "Контакты",
  "t-alert-rule": "Правило оповещения",
  "t-email-alert-template": "Шаблон оповещения по электронной почте",
  "t-email-template": "Шаблоны электронной почты",
  "t-alert-rule-template": "шаблон правила",
  "t-template-title": "Заголовок шаблона",
  "t-template": "Заголовок",
  "t-from-name": "Имя отправителя",
  "t-email-alert-content": "Содержание шаблона электронной почты",
  "t-search-alert": "Название уведомления о поиске",
  "t-alert-notice": "Уведомление о тревоге",
  "t-alert-policy": "Политика оповещения",
  "t-policy": "политика",
  "t-alert-contacts": "Контакты для оповещения об аварии",
  "t-alert-start-time": "Время вступления в силу",
  "t-alert-механизм": "механизм оповещения",
  "t-notice-channels": "каналы уведомлений",
  "t-channels": "канал",
  "t-first-sequence-notifier": "Уведомитель первой последовательности",
  "t-second-sequence-notifier": "Уведомитель второй последовательности",
  "t-third-sequence-notifier": "Уведомитель третьей последовательности",
  "t-notification-interval": "Интервал между следующими уведомлениями",
  "t-error-sms-not-enable": "Не настроена включенная конфигурация SMS-шлюза ",
  "t-error-email-not-enable": "Не настроена включенная почтовая конфигурация",
  "t-enable-fence-alert": "Включить предупреждение о ограде",
  "t-policy-alert-rule-content": "Правило тревоги",
  "t-alert-channel-template-configuration": "Конфигурация шаблона канала оповещения",
  "t-available-merge-fields": "Доступные поля слияния",
  "t-sunday": "воскресенье",
  "t-monday": "понедельник",
  "t-tuesday": "вторник",
  "t-wednesday": "среда",
  "t-thursday": "четверг",
  "t-friday": "пятница",
  "t-saturday": "суббота",
  "t-notifying-user": "уведомлять пользователя",
  "t-notifying-partner": "уведомление партнера",
  "t-notifying-customer": "уведомлять клиента",
  "t-notifying-merchat": "уведомлять торговца",
  "t-notifying-text-message": "смс",
  "t-notifying-info": "Информация о уведомлении",
  "t-alert-status": "Статус уведомления",
  "t-alert-time": "Время тревоги",
  "t-ui": "UI",
  "t-wallpaper": "обои",
  "t-boot-picture": "Первый кадр при включении",
  "t-boot-animation": "Анимация при включении",
  "t-log-report": "Аудит и отчетность",
  "t-entity-value": "значение сущности",
  "t-system-health": "Здоровье системы",
  "t-gateway": "шлюз",
  "t-configuration": "конфигурация",
  "t-health": "здоровье ",
  "t-audit-logs": "аудитные журналы",
  "t-tickets": "Рабочий заказ",
  "t-disconnect": "отключить",
  "t-received": "получено",
  "t-unreceived": "не получено",
  "t-subject": "тема",
  "t-user-mgmt": "Управление пользователями",
  "t-user": "пользователь",
  "t-authorities": "роль",
  "t-reset-password": "сброс пароля",
  "t-activate-token": "Многофакторная аутентификация",
  "t-replace-token": "Заменить MFA",
  "t-activate-user": "Активировать пользователя",
  "t-activate": "активировать",
  "t-deactivate": "отключить",
  "t-reboot": "перезапуск",
  "t-warning-to-reboot": "Вы уверены, что хотите перезагрузить устройство?",
  "t-warning-to-unbind": "Вы уверены, что хотите отвязать эту запись?",
  "t-lock": "заблокировать",
  "t-lock-device": "Заблокировать устройство",
  "t-warning-to-lock": "Вы уверены, что хотите заблокировать устройство?",
  "t-unlock": "Разблокировать",
  "t-warning-to-unlock": "Вы уверены, что хотите разблокировать устройство?",
  "t-factory-settings": "Восстановление заводских настроек",
  "t-warning-to-reset": "Вы уверены, что хотите сбросить устройство до заводских настроек? Эта операция приведет к потере данных. Вы уверены?",
  "t-warning-to-shut-down": "Вы уверены, что хотите выключить устройство?",
  "t-warning-to-disable-geo-tracking": "Вы уверены, что хотите отключить геотрекинг?",
  "t-shut-down-device": "Выключение устройства",
  "t-enable-geo-tracking": "Включить геотрекинг",
  "t-disable-geo-tracking": "Отключить геотрекинг",
  "t-warning-to-geo-tracking": "Обратите внимание, включение геотрекинга приведет к расходу заряда батареи",
  "t-device-geo-tracking-not-enable": "Устройство не активировано для геотрекинга",
  "t-device-geo-tracking-has-enable": "Устройство активировано для геотрекинга",
  "t-enter-package-name": "Введите имя пакета",
  "t-device-sn": "серийный номер устройства",
  "t-device-license-file-does-not-exist": "Файл лицензии устройства не существует",
  "t-device-under-activation": "Устройство находится в состоянии ожидания активации или неактивировано",
  "t-device-is-out-of-range-activation-failed": "Устройство находится вне диапазона, активация не удалась",
  "t-sync": "синхронизация",
  "t-cancel-geo-fencing": "Отменить геозону",
  "t-warning-to-cancel-geo-fencing": "Вы уверены, что хотите отменить геозону?",
  "t-device-not-support-pubkey-synchronization": "Устройство не поддерживает синхронизацию открытого ключа. Проверьте устройство",
  "t-device-geo-location": "геолокация устройства",
  "t-geo-location": "географическое положение",
  "t-longitude": "долгота",
  "t-latitude": "широта",
  "t-device-unbind-successful": "Успешно отвязано устройство",
  "t-device-bind-successful": "Успешное связывание устройства",
  "t-wait-pend": "В процессе. Просим подождать ответа устройства",
  "t-warning-to-activate-kiosk": "Вы уверены, что хотите активировать режим полноэкранного отображения?",
  "t-setting-version-type-general": "Если эта версия настроена как общая версия, то следующие приложения будут изменены на серую версию",
  "t-error-application-not-function": "Системное приложение не может выполнить эту операцию",
  "t-error-device-no-application": "На устройстве нет этого приложения",
  "t-warning-to-deactivate-kiosk": "Вы уверены, что хотите отключить режим полноэкранного отображения?",
  "t-device-need-specified-area": "Это устройство должно вернуться в указанную область",
  "t-device-need-specified-fence": "Это устройство должно вернуться к указанному ограждению",
  "t-recover-key-success": "Запрос на инициализацию ключа устройства отправлен успешно",
  "t-error-domineering-state-already": "Уже есть другое приложение в состоянии доминирования экрана",
  "t-app-has-dominated": "Это приложение уже заняло весь экран. Просим вас больше не отправлять команды для заполнения экрана.",
  "t-error-app-not-domineering-state": "Это приложение не находится в состоянии доминирования на экране",
  "t-error-device-not-app-in-dominant-state": "Устройство не имеет приложения в доминирующем состоянии",
  "t-error-current-domineering-state-already": "Текущее приложение уже находится в доминирующем состоянии на экране",
  "t-warning-to-uninstall": "Вы уверены, что хотите удалить приложение",
  "t-warning-to-uninstall-block": "Вы уверены, что хотите удалить запрещение на удаление приложения",
  "t-application-in-kiosk-mode": "Приложение находится в режиме полноэкранного отображения. Просим сначала отключить режим полноэкранного отображения",
  "t-uninstall-application": "Удалить приложение",
  "t-device-not-activated": "устройство не активировано",
  "t-request-sent-device": "Запрос успешно отправлен на устройство",
  "t-activate-request-sent": "Успешно отправлено запрос на активацию устройству",
  "t-error-updating-device": "Произошла ошибка при обновлении устройства",
  "t-storm-restore-factory-settings": "STORM - восстановление заводских настроек",
  "t-device-restore-factory-settings": "Устройство - Восстановление заводских настроек",
  "t-first-name": "имя",
  "t-last-name": "Фамилия",
  "t-deactivated": "Отключен",
  "t-activated": "активирован",
  "t-role": "роль",
  "t-permissions-name-connot-replace": "Формат имени не соответствует. Имя не может быть равно ни одному из “ROLE_ADMIN”, “ROLE_OPERATOR”, “ROLE_PARTNER” или “ROLE_USER”.",
  "t-auto-generate-password": "Автоматически генерировать пароль",
  "t-deactivate-user": "Отключить пользователя",
  "t-role-permissions": "роли и разрешения",
  "t-permissions": "права",
  "t-read": "читать",
  "t-write": "писать",
  "t-push": "Пуш",
  "t-record": "запись",
  "t-tid": "TID",
  "t-mid": "MID",
  "t-imei": "IMEI",
  "t-disable": "Превышение ограждения страны и региона",
  "t-tamper": "Разборка устройства",
  "t-de-tamper": "Отмена демонтажа устройства",
  "t-report": "Отчет",
  "t-report-settings": "Настройки отчетов",
  "t-report-download": "Отчет загрузить",
  "t-sort-digit": "Сортировать цифры",
  "t-universal": "универсальный",
  "t-widget": "контрол",
  "t-conditions": "условия",
  "t-attribute-code": "код атрибута",
  "t-attribute-name": "имя атрибута",
  "t-attribute": "атрибута",
  "t-data-type": "тип данных",
  "t-attribute-type": "Тип атрибута",
  "t-language-type": "Тип языка",
  "t-enumerated-value": "перечисляемое значение",
  "t-enumerated-name": "Перечисляемое имя",
  "t-association": "ассоциация",
  "t-sql": "SQL",
  "t-chart": "график",
  "t-pie-chart": "круговая диаграмма",
  "t-bar-chart": "столбчатая диаграмма",
  "t-line-chart": "линейная диаграмма",
  "t-time-frame": "диапазон времени",
  "t-enumeration": "перечисление",
  "t-string": "строка",
  "t-internationalization": "интернационализация",
  "t-language": "язык",
  "t-charts": "таблицы",
  "t-fixed-report": "статическая отчетность",
  "t-dynamic-report": "Динамическая отчетность",
  "t-reason": "причина",
  "t-numbers-letter": "Состоит из заглавных и строчных букв, цифр и дефисов",
  "t-input-invalid-pattern-default": "Состоит из цифр, букв, подчеркивания, точек и пробелов, поддерживает китайский, английский, французский, русский и испанский языки, не может начинаться или заканчиваться пробелом",
  "t-input-invalid-pattern-user-name": "Состоит из цифр, букв и пробелов, поддерживает китайский, английский, французский, русский и испанский языки, не может начинаться или заканчиваться пробелом",
  "t-input-invalid-pattern-phone": "Состоит из цифр, тире, + и пробелов. Не может начинаться и заканчиваться пробелом или тире. Пробелы и тире не могут вводиться последовательно. Номер с кодом региона начинается с + или 00",
  "t-input-invalid-pattern-website": "составлено в формате URL",
  "t-input-invalid-pattern-host": "Состоит в формате IP-адреса",
  "t-input-invalid-pattern-email": "Пример формата почты :abc@ftsafe.com",
  "t-input-invalid-pattern-smtp": "Составлено в формате доменного имени SMTP",
  "t-input-invalid-pattern-sn": "Состоит из прописных и строчных букв, цифр и дефисов",
  "t-input-invalid-pattern-imei": "Состоит только из цифр",
  "t-input-invalid-pattern-device-imei": "IMEI может содержать только цифры",
  "t-input-invalid-pattern-tid": "Состоит из больших и маленьких букв и цифр",
  "t-input-invalid-pattern-key": "Состоит из заглавных и строчных букв, точек и цифр",
  "t-t-input-invalid-pattern-key-number": "Состоит из заглавных и строчных букв, точек и цифр",
  "t-input-invalid-pattern": "Пожалуйста, введите допустимое значение. Обратите внимание, что символы в начале и конце не могут быть пробелами",
  "t-input-invalid-pattern-password": "Введите допустимое значение. Должен содержать хотя бы одну цифру или букву. Обратите внимание, что первый и последний символы не могут быть пробелами",
  "t-minlength-valid-pattern": "Минимальное ограничение символов - ",
  "t-maxlength-valid-pattern": "Максимальное ограничение символов - ",
  "t-file-maximum-size": "Максимальный размер файла",
  "t-file-upload-right-spec": "Просим загрузить файл, соответствующий требованиям",
  "t-model-name": "название модели",
  "t-log-info": "Информация о журнале",
  "t-clean-success": "успешно очищено",
  "t-push-event-id": "Идентификатор события push",
  "t-operation": "операция",
  "t-input-password-mismatch": "Пароли не совпадают",
  "t-generated": "сгенерированный",
  "t-entity": "сущность",
  "t-entity-name": "название сущности",
  "t-minutes": "минуты",
  "t-hours": "часы",
  "t-app-incremental-upgrade": "Инкрементное обновление приложения",
  "t-restart": "перезапуск",
  "t-shutdown-device": "Устройство отключения",
  "t-system-parameter": "системный параметр",
  "t-start": "начать",
  "t-end": "конец",
  "t-stop": "остановка",
  "t-time": "время",
  "t-geo-fencing": "географическая оградка",
  "t-initialization": "инициализация",
  "t-erase": "снять",
  "t-initial-key": "Инициализация секретного ключа",
  "t-geo-tracking": "географическое отслеживание",
  "t-automatic": "автоматический",
  "t-sma-data-synchronization": "Синхронизация данных SMA",
  "t-pubkey-synchronization": "синхронизация открытого ключа",
  "t-push-select-device-group": "Пожалуйста, выберите устройство или группу, которое нужно отправить",
  "t-m20-transaction-param": "Параметр транзакции M20",
  "t-push-status-push-sent": "Пуш-уведомление отправлено",
  "t-push-status-push-received": "Получено уведомление о_push",
  "t-push-status-downloading": "Загрузка",
  "t-push-status-installing": "Установка",
  "t-push-status-executing": "Выполняется",
  "t-push-status-success": "успех",
  "t-push-status-fail": "Неудача",
  "t-push-status-app-not-signed": "Неудача, приложение не подписано",
  "t-push-status-install-later": "Установить позже",
  "t-push-status-higher-version-exist": "Неудача, существует более высокая версия приложения",
  "t-push-status-app-not-installed": "Неудача, приложение не установлено",
  "t-push-status-broadcast-transmitted": "Броадкаст был передан",
  "t-push-status-increment-file-error": "Неудача, ошибка инкрементного файла",
  "t-push-status-file-format-error": "Неудача, ошибка формата файла",
  "t-push-status-download-file-error": "Неудача, ошибка при скачивании файла",
  "t-push-status-task-reached-the-maximum": "Неудача, задача достигла максимума",
  "t-push-status-insufficient-electricity": "Неудача, недостаточно электричества. Пожалуйста, повторите попытку позже",
  "t-push-status-app-patch-updating": "Обновление патча приложения",
  "t-push-status-app-patch-update-error": "Неудача, ошибка обновления патча приложения",
  "t-push-status-parameter-error": "Неудача, ошибка параметра",
  "t-push-status-download-completed": "Загрузка завершена",
  "t-push-status-same-task-exist": "Неудача, существует такая же задача",
  "t-push-status-push-uploading": "В процессе загрузки на сервер",
  "t-push-status-push-ota-file-mismatch": "Неудача, файл OTA для отправки не соответствует",
  "t-push-status-start-capture": "Начать захват",
  "t-push-status-stop": "остановить",
  "t-push-status-key-parameter-error": "Неудача, ошибка параметра ключа ",
  "t-push-status-already-activated": "уже активирован",
  "t-push-status-no-space-left-on-device": "Неудача, на устройстве не осталось свободного места для хранения ",
  "t-push-status-initkey-failed": "Успешно отменили предупреждение о демонтаже оборудования, но не удалось инициализировать ключ",
  "t-push-status-erase-tamper-failed": "Неудача, не удалось снять предупреждение о вмешательстве в разборку",
  "t-push-status-close-2nd-sig-failed": "Неудача, не удалось закрыть вторую подпись",
  "t-push-status-open-2nd-sig-failed": "Неудача, не удалось открыть вторую подпись",
  "t-push-status-verify-2nd-sig-cert-failed": "Неудача, не удалось подтвердить сертификат второй подписи",
  "t-push-status-push-to-pulsar-failed": "Неудача, отправка в Pulsar не удалась",
  "t-push-status-push-to-mpush-failed": "Неудача, отправка в Mpush не удалась",
  "t-push-status-status-push-sp-server-is-busy": "SP-сервер занят ",
  "t-push-status-reverted": "отменено",
  "t-push-status-factory-setting-cause-no-log": "Неудача, восстановление заводских настроек привело к отсутствию журнала записей",
  "t-push-status-md5-verification-failed": "Неудача, проверка MD5 не удалась",
  "t-push-status-device-offline": "Устройство отключено. Пожалуйста, повторите попытку позже",
  "t-push-status-mpush-push-to-device-fail": "Mpush отправка на устройство не удалась. Пожалуйста, повторите попытку позже",
  "t-push-status-download-completed-wait-for-upgrade": "Загрузка завершена, ожидание обновления",
  "t-push-status-push-event-has-been-fetched": "Пуш-ивент был получен",
  "t-push-status-get-push-event-fail": "Неудача, не удалось получить событие отправки",
  "t-push-status-apk-install-failed-invalid": "Неудача,_push APK недействителен",
  "t-push-status-apk-install-failed-system-mistake": "Неудача, системная ошибка при установке APK",
  "t-push-status-apk-install-failed": "Неудача, при установке APK наблюдаются проблемы с SD-картой или недостаточно памяти для хранения",
  "t-push-status-apk-install-failed-certificate-mistake": "Неудача, ошибка сертификата при установке APK",
  "t-push-status-apk-install-failed-other": "Неудача, установка APK не удалась, по другим причинам",
  "t-push-status-init-key-failed": "Неудача, не удалось инициализировать ключ",
  "t-push-status-kiosk-mode-in-progress": "Неудача, устройство находится в режиме полноэкранного отображения",
  "t-push-status-network-issue": "Неудача, проблема с сетью. Пожалуйста, повторите попытку позже",
  "t-push-status-network-failed": "Неудача, состояние сети устройства ненормально",
  "t-push-status-unsupported-action": "Неудача, бизнес, не поддерживаемый устройством",
  "t-push-status-initialization-interupted": "Неудача, инициализация прервана",
  "t-push-status-cert-install-failed": "Неудача, установка сертификата не удалась",
  "t-push-status-apk-install-failed-device-os-version-not-support": "Неудача, версия ОС не поддерживает подпись V2",
  "t-push-status-invalid-apk-file-caused-signature-failure": "Неудача, подпись не удалась из-за недействительного файла APK",
  "t-push-status-device-unusual-status-unactive": "Неудача, устройство не активировано",
  "t-push-status-device-unusual-status-geoFence": "Неудача, устройство вышло за пределы геозоны",
  "t-push-status-device-unusual-status-regionOut": "Неудача, устройство выходит за пределы географической зоны страны ",
  "t-push-status-device-unusual-status-tamper": "Неудача, устройство находится в состоянии демонтажа",
  "t-push-status-device-unusual-status-regionOut-tamper": "Неудача, устройство выходит за пределы географической зоны страны и находится в состоянии демонтажа",
  "t-push-status-device-unusual-status-region-geoFence": "Неудача, устройство вышло за пределы регионального и географического ограждения страны",
  "t-push-status-device-unusual-status-under-activation": "Неудача, устройство находится в состоянии ожидания активации",
  "t-push-status-app-not-enable-kiosk-mode": "Неудача, режим киоск не включен",
  "t-push-status-device-region-geoFence-tamper": "Неудача, устройство выходит за пределы географического забора страны и региона, находится в аномальном состоянии демонтажа и выходит за пределы географического забора",
  "t-push-status-device-geoFence-tamper": "Неудача, устройство вышло за пределы геозоны и находится в аномальном состоянии демонтажа",
  "t-push-status-push-has-expired-please-try-again": "Задача на отправку истекла. Пожалуйста, повторите попытку",
  "t-push-status-public_key_no_mismatch": "Отсутствие соответствия открытого ключа устройства",
  "t-push-status-device-upgrading": "Устройство находится в процессе обновления",
  "t-data-exception-sync-completed": "Данные аномалии, синхронизация завершена",
  "t-data-is-normal-no-need-to-sync": "Данные в норме, синхронизация не требуется",
  "t-pubkey-uploaded": "Загрузка открытого ключа",
  "t-pubkey-exception-sync-completed": "Публичный ключ имеет отклонение, синхронизация завершена",
  "t-system-param-version": "Версия системного параметра",
  "t-profile": "профиль конфигурации",
  "t-profile-details": "Детали профиля",
  "t-wallpaper-file": "файл обоев",
  "t-picture-file": "Файл первого кадра при включении",
  "t-animation-file": "Файл анимации при включении",
  "t-server-mfm-picture-resolution-not-match": "Загрузка не удалась, разрешение изображений в архиве не соответствует!",
  "t-server-mfm-picture-format-not-match": "Загрузка не удалась, формат изображений в архиве не соответствует!",
  "t-server-mfm-boot-animatio-upload-failed": "Загрузка не удалась. Содержимое файла zip не соответствует правилам изображений анимации при включении!",
  "t-server-mfm-resolution-and-model-version-not-match": "Загрузка не удалась. Разрешение и формат файла не соответствуют версии модели!",
  "t-key-capture-records-status-hsm-error": "Ошибка HSM",
  "t-key-capture-records-status-kcv-value-error": "Ошибка значения ключа KCV",
  "t-date-range-90-day": "Выбранный диапазон дат не должен превышать 90 дней",
  "t-select-start-end-time": "Необходимо выбрать время начала и окончания ",
  "t-In Progress": "В процессе",
  "t-Approved": "одобрено",
  "t-action-type": "тип действия",
  "t-client": "Kлиента",
  "t-client-ip": "Адрес IP клиента",
  "t-add.profile.check.application": "Убедитесь, что подпись APK успешна",
  "t-select.identical.application": "Вы выбрали повторное приложение",
  "t-log-details": "Описание объекта операции",
  "t-key-capture-records-status-public-key-not-exist": "Отсутствует открытый ключ устройства",
  "t-log-capture-not-start": "Захват не начался",
  "t-log-capture-completed": "Завершено захват",
  "t-log-capture-failed": "Не удалось захватить",
  "t-log-capture-capturing": "В процессе захвата",
  "t-plaintext": "открытый текст",
  "t-cipher": "Шифротекст",
  "t-bdk-lmk": "BDK / LMK",
  "t-error-match-password": "Пароли не совпадают дважды",
  "t-ui-settings": "Настройки UI",
  "t-license-mgmt": "Управление лицензиями",
  "t-license": "авторизация",
  "t-license-settings": "Настройки лицензирования",
  "t-tamper-authorization-times": "Количество разрешений на вскрытие устройства",
  "t-number-assignable-authorizations": "Количество передаваемых авторизаций",
  "t-license-information": "Авторизованный Пользователь",
  "t-allocate-authorization": "распределение авторизации",
  "t-add-allocate-authorization": "увеличить выделение полномочий",
  "t-edit-allocate-authorization": "Авторизация распределения редактирования",
  "t-authorization-times": "количество авторизаций",
  "t-remaining-times": "остаточное количество раз",
  "t-enter-authorization.times": "Количество вводов авторизации",
  "t-email-use-for-code": "Электронная почта для получения кода OTP",
  "t-allocate-authorization-created-successfully": "Авторизация распределения {param} создана успешно!",
  "t-allocate-authorization-updated.successfully": "Обновление распределения полномочий {param} успешно!",
  "t-allocate-authorization-updated-times-successfully": "Успешно обновлено количество раз выделения авторизации!",
  "t-error-allocate-authorization-created": "Произошла ошибка при создании распределения авторизации",
  "t-error-allocate-authorization-updated": "Произошла ошибка при обновлении выделения авторизации",
  "t-error-allocate-authorization-updated.times": "Произошла ошибка при обновлении количества распределенных авторизаций",
  "t-correct": "Правильно",
  "t-check-kcv-values": "Введите два значения",
  "t-adb-enable": "ADB",
  "t-bluetooth-enable": "Блютуз",
  "t-mobile-data-enable": "Мобильные данные",
  "t-nfc-enable": "NFC",
  "t-hot-spot-enable": "горячая точка",
  "t-on": "ВКЛ",
  "t-off": "OFF",
  "t-no-content-selected": "Ничего не выбрано",
  "t-m": "минуты",
  "t-action-list": "список действий",
  "t-key-capture-records-sn-repeatedly": "SN нельзя повторно импортировать",
  "t-key-capture-records-sn-empty": "SN не может быть пустым",
  "t-key-capture-records-key-value-empty": "ЗНАЧЕНИЕ КЛЮЧА НЕ МОЖЕТ БЫТЬ ПУСТЫМ",
  "t-key-capture-records-kcv-empty": "KCV не может быть пустым",
  "t-key-capture-records-device-not-exist": "Устройство не существует",
  "t-key-capture-records-sn-not-bound-partner": "SN еще не привязан к партнеру",
  "t-key-capture-records-device-not-belong-user": "Это устройство не принадлежит текущему пользователю",
  "t-key-capture-records-device-not-activated": "Устройство не активировано",
  "t-key-capture-records-key-applied-device-model": "Ключ не может быть применен к этой модели устройства",
  "t-key-capture-records-failed-verify-countries-currencies": "Не удалось подтвердить соответствующие страны и валюты",
  "t-key-capture-records-tid-format-mismatch": "Несоответствие формата TID",
  "t-key-capture-records-tid-repeated": "TID уже повторяется",
  "t-key-capture-records-tid-not-match-country-region": "Количество TID, количество стран/регионов и количество валют не соответствуют друг другу",
  "t-key-capture-records-country-currency-not-empty": "Страна и валюта не могут быть пустыми, поскольку TID не пустой",
  "t-key-capture-records-tid-not-empty": "Страна/регион или валюта не пусты, TID не может быть пустым",
  "t-key-capture-records-kcv-keyvalue-mismatch": "Несоответствие значения ключа KCV",
  "t-expiry-date": "срок истечения",
  "t-papers-available": "Не не хватает бумаги",
  "t-out-of-papers": "Нет бумаги или не поддерживается",
  "t-lack-of-paper": "Отсутствие бумаги",
  "t-bind-device-information-details": "Подробная информация о привязке устройства",
  "t-unbind-device-information-details": "Детали отвязки информации об устройстве",
  "t-device-has-been-bind-partner-file": "Устройство уже привязано к файлу партнера (нажмите для скачивания)",
  "t-device-bind-confirm-info": "Это устройство уже привязано к партнеру. Действительно ли вы хотите привязать его к",
  "t-role-type": "тип роли",
  "t-user-type": "Тип пользователя",
  "t-user-source": "источник пользователя ",
  "t-json": "JSON",
  "t-excel": "Excel",
  "t-release-notes": "Примечания о выпуске",
  "t-cloud-message": "облачное сообщение",
  "t-select-duration": "Выбрать диапазон истечения срока",
  "t-onboard-merchants": "Регистрация торговцев",
  "t-access-key": "ключ доступа",
  "t-notifications": "уведомления",

  "t-signIn": "Вход",
  "t-email-userName": "Электронная почта/имя пользователя",
  "t-forgot-password": "забыл пароль",
  "t-devices": "устройство",
  "t-manufacturer-name": "название производителя",
  "t-manipulate": "операция",
  "t-firmwares": "прошивки",
  "t-applications": "приложения",
  "t-group-management": "Групповое управление",
  "t-key-capture-event-id": "ID события генерации ключа",
  "t-key-capture-records": "Записи о генерации ключей",
  "t-key-capture-records-details": "Детали записей о генерации ключей",
  "t-search-key-capture-records-details": "Подробности о записях поиска",
  "t-key-capture-records-status-success": "успех",
  "t-file-management": "Файловое управление",
  "t-ads-reporter": "Записи о рекламных рассылках",
  "t-push-scheduler": "Планировщик push",
  "t-device-import": "импорт устройства",
  "t-manufacturer-import": "Производитель. Импорт",
  "t-partner-import": "Импорт партнера",
  "t-customer-import": "Импорт клиентов",
  "t-merchant-import": "Импорт торговца",
  "t-store-import": "импорт магазина",
  "t-key-import": "импорт ключа",
  "t-device-upstream": "устройство.вверх",
  "t-device-downstream": "устройство.нисходящий",
  "t-user-management": "Управление пользователями",
  "t-roles-permissions": "роли.права",
  "t-brands": "HSM",
  "t-ui-management": "Управление UI",
  "t-system-params": "Системные параметры",
  "t-keys-management": "Управление ключами",
  "t-media": "медиа",
  "t-import-mgmt": "Управление импортом",
  "t-log-mgmt": "Управление журналами",
  "t-system-mgmt": "Системное управление",
  "t-add-device": "Добавить устройство",
  "t-edit-device": "редактировать устройство",
  "t-placeholder-enter-sn": "Введите серийный номер",
  "t-error-enter-sn": "Название серийного номера является обязательным полем",
  "t-error-enter-valid-sn": "Серийный номер допускает только ввод больших и маленьких букв латинского алфавита, цифр и дефиса",
  "t-error-enter-valid-tid": "TID допускает только ввод прописных и строчных букв, цифр и дефисов",
  "t-error-enter-minlength-sn": "Длина серийного номера не может быть меньше 2",
  "t-error-enter-minlength-tid": "Длина TID не может быть меньше 2",
  "t-placeholder-enter-imei": "Введите IMEI",
  "t-update-imei-successfully": "Успешно обновлено IMEI",
  "t-error-enter-imei": "IMEI является обязательным полем",
  "t-error-enter-minlength-imei": "Длина IMEI не может быть меньше 2",
  "t-error-enter-valid-imei": "IMEI может содержать только цифры",
  "t-error-enter-valid-pusheventid": "ID события push может содержать только цифры",
  "t-placeholder-enter-tid-name": "Введите имя TID",
  "t-error-enter-tid-name": "Название TID является обязательным полем",
  "t-error-model-version-required": "Версия модели обязательна",
  "t-save-changes": "сохранить изменения",
  "t-saving": "сохранение...",
  "t-search-by-model-name": "Поиск по названию модели",
  "t-search-device": "Поисковое устройство",
  "t-bind-devices": "Привязка устройств",
  "t-unbind-devices": "Отвязать устройства",
  "t-export-to-excel": "Экспорт в Excel",
  "t-select-model-version": "-версия модели -",
  "t-search-by-name": "Поиск по имени",
  "t-all": "все",
  "t-search-selected-device": "Поиск выбранного устройства",
  "t-search-available-device": "Поиск доступного устройства",
  "t-required-partner": "Партнер является обязательным полем",
  "t-enter-manufacturer": "Введите название производителя",
  "t-loading-dashboard": "Загрузка модуля приборной панели...",
  "t-signing-in": "Вход в систему...",
  "t-error-manufacturer-required": "Название производителя обязательно",
  "t-enter-website": "Введите веб-сайт",
  "t-error-url-required": "Пожалуйста, введите действительный URL",
  "t-select-logo": "Выбор логотипа",
  "t-add-manufacturer": "Добавить производителя",
  "t-edit-manufacturer": "редактировать производителя",
  "t-error-loading-category": "Произошла ошибка при загрузке категории",
  "t-error-loading-group": "Произошла ошибка при загрузке группы",
  "t-error-loading-production-batch": "Произошла ошибка при загрузке производственной партии",
  "t-error-loading-sales-batch": "Произошла ошибка при загрузке партии продаж",
  "t-error-loading-model-version": "Произошла ошибка при загрузке версии модели",
  "t-error-loading": "Ошибка загрузки",
  "t-timeline-device-title": "Жизненный цикл устройства",
  "t-device-created-successfully": "Устройство {sn} успешно создано!",
  "t-error-created-device": "Произошла ошибка при добавлении устройства",
  "t-device-updated-successfully": "Устройство {sn} успешно обновлено!",
  "t-error-updated-device": "Произошла ошибка при обновлении устройства",
  "t-package-name-required": "Название пакета обязательно",
  "t-submit-kiosk": "представить",
  "t-uninstall-app": "Удалить приложение",
  "t-uninstall-application-successfully": "Приложение успешно удалено",
  "t-error-occurred": "Произошла ошибка",
  "t-no-data-avaliable": "нет доступных данных",
  "t-no-data": "нет доступных",
  "t-no-data-selected": "Не выбраны данные ",
  "t-lat": "широта",
  "t-lng": "долгота",
  "t-device-out-of-region": "Это устройство находится за пределами региона. Проверьте регион, в котором находится устройство",
  "t-technical-details": "технические детали",
  "t-android-security-level": "Уровень безопасности Android",
  "t-google-play-system-update": "Обновление системы Google Play",
  "t-en": "EN",
  "t-android-version": "Версия Android",
  "t-base-band-version": "версия базовой полосы",
  "t-battery-usage": "Пользование батареи",
  "t-cpu-usage": "Использование CPU",
  "t-emv-kernel-version": "Версия ядра EMV",
  "t-express-pay-kernel-version": "Версия ядра Express Pay",
  "t-ifm-module-name-version": "Версия контактной карты庫 ",
  "t-jspeedy-kernel-version": "Версия ядра JSpeedy",
  "t-bootloader": "загрузчик",
  "t-kernel-version": "версия ядра",
  "t-pay-pass-kernel-version": "Версия ядра Pay Pass",
  "t-pay-wave-kernel-version": "Версия ядра Pay Wave",
  "t-pcd-module-name-version": "Версия библиотеки для бесконтактных карт",
  "t-platform-type": "тип платформы",
  "t-printer-density": "Градация принтера",
  "t-quics-kernel-version": "Версия ядра QUICS",
  "t-ram": "оперативная память",
  "t-ram-usage": "Использование оперативной памяти",
  "t-screen-density": "плотность экрана",
  "t-storage": "хранение",
  "t-storage-usage": "Использование хранилища",
  "t-cortex-scanner-version": "Версия сканера Cortex",
  "t-signal-type": "Тип сигнала",
  "t-telecom-operators": "операторы",
  "t-tamper-operation": "Двойной щелчок для отмены предупреждения о демонтаже устройства",
  "t-network-status": "состояние сети",
  "t-system-status": "Системное состояние",
  "t-gb": "GB)",
  "t-device-activated-successfully": "Устройство активировано успешно!",
  "t-check-device-status": "Проверьте, работает ли устройство нормально",
  "t-error-device-updated": "Не удалось обновить состояние устройства",
  "t-device-status-updated-successfully": "Успешно обновлен статус устройства",
  "t-clear-tamper": "Просим сначала очистить предупреждение о вскрытии устройства",
  "t-model-created-successfully": "Модель {sn} успешно создана!",
  "t-model-updated-successfully": "Модель {sn} успешно обновлена!",
  "t-model-deleted-successfully": "Модель {param} успешно удалена!",
  "t-error-creating-model": "Произошла ошибка при добавлении модели",
  "t-error-loading-model": "Произошла ошибка при загрузке модели",
  "t-error-loading-manufacturers": "Произошла ошибка при загрузке производителей",
  "t-error-loading-manufacturer": "Произошла ошибка при загрузке производителя",
  "t-add-model": "Добавить модель",
  "t-collapse": "крах",
  "t-restore": "восстановить",
  "t-no-result-found": "Не найдено результатов",
  "t-search-model": "модель",
  "t-search-manufacturer": "Производитель",
  "t-enter-model-name": "Введите название модели",
  "t-model-name-required": "Название модели обязательно",
  "t-manufacturer-required": "Производитель - обязательное поле",
  "t-model-deleted ": "Модель удалена успешно",
  "t-error-deleting-model": "Произошла ошибка при удалении модели",
  "t-add-model-version": "Добавить версию модели",
  "t-edit-model-version": "редактировать версию модели",
  "t-image-upload": "Загрузка изображения",
  "t-please-upload": "Просим загрузить изображение",
  "t-maximum-file-size": "Размер файла не должен превышать 300 КБ",
  "t-maximum-file-size-6m": "Размер файла не должен превышать 6 MБ",
  "t-please-upload-file-type": "Просим загрузить файлы типов bin, zip",
  "t-please-upload-certificate-file": "Просим загрузить файл сертификата",
  "t-please-upload-apk": "Просим загрузить файл apk",
  "t-please-upload-dat-zip": "Просим загрузить файлы dat или zip",
  "t-device-binding": "Устройство привязки",
  "t-device-unbinding": "Отвязка устройства",
  "t-enter-version-name": "Введите имя версии",
  "t-version-name-required": "Имя версии обязательно",
  "t-year": "год",
  "t-select-year": "Выбрать год",
  "t-year-required": "Год является обязательным полем",
  "t-enter-valid-year": "Введите действительный год",
  "t-select-icon": "Выбрать иконку",
  "t-resolution-required": "Разрешение является обязательным полем",
  "t-model-required": "Модель обязательна для заполнения",
  "t-search-model-version": "Модель версии",
  "t-delete-model-version-confirmation": "Подтверждение удаления версии модели",
  "t-delete-model-version": "Вы уверены, что хотите удалить версию модели - {param}?",
  "t-error-deleting-model-version": "Произошла ошибка при удалении версии модели",
  "t-select-valid-model": "Пожалуйста, выберите действительную модель",
  "t-confirm-delete-operation": "Подтвердить операцию удаления",
  "t-warning-to-delete": "Вы уверены, что хотите удалить -{param}?",
  "t-manufacturer-deleted": "Производитель {param} успешно удален!",
  "t-model-version-deleted": "Модельная версия {param} успешно удалена!",
  "t-mfa-configuration": "Партнерские настройки",
  "t-error-fill-mandatory-fields": "Просим заполнить все обязательные поля",
  "t-processing": "В процессе обработки",
  "t-reset-email-sent": "Электронное письмо для сброса пароля отправлено",
  "t-delete-model-confirmation": "Подтверждение удаления модели",
  "t-delete-confirmation-model": "Вы уверены, что хотите удалить модель - {param}?",
  "t-device-deleted-successfully": "Устройство {param} успешно удалено!",
  "t-error-deleted-device": "Произошла ошибка при удалении устройства",
  "t-error-loading-devices": "Произошла ошибка при загрузке устройств",
  "t-no-response-from-device": "Отсутствует ответ от устройства",
  "t-installed-applications": "установленные приложения",
  "t-add-application": "добавить приложение",
  "t-edit-application": "редактировать приложение",
  "t-add-application-version": "Добавление версии приложения",
  "t-edit-application-version": "Редактирование версии приложения",
  "t-application-version-saved-successfully": "Версия приложения {param} успешно сохранена!",
  "t-application-version-updated-successfully": "Версия приложения {param} успешно обновлена!",
  "t-search-application-version": "Версия приложения",
  "t-application-device-name": "Название приложения",
  "t-version-name": "название версии",
  "t-select-valid-application": "Пожалуйста, выберите действительное приложение",
  "t-delete-application-version-confirmation": "Подтверждение удаления версии приложения",
  "t-warning-delete-application-version": "Вы уверены, что хотите удалить версию приложения - {param}?",
  "t-application-version-deleted": "Версия приложения {param} успешно удалена!",
  "t-error-deleting-application-version": "Произошла ошибка при удалении версии приложения",
  "t-error-application-name-required": "Название приложения обязательно",
  "t-error-application-pattern": "Название приложения состоит из букв, цифр, подчеркивания, точек и пробелов и не может начинаться или заканчиваться пробелом",
  "t-placeholder-enter-application-name": "Введите название приложения",
  "t-placeholder-enter-application-description": "Введите описание приложения",
  "t-error-loading-application": "Произошла ошибка при загрузке приложения",
  "t-application-created-successfully": "Приложение {param} успешно создано!",
  "t-error-created-application": "Произошла ошибка при создании приложения",
  "t-application-updated-successfully": "Приложение {param} успешно обновлено!",
  "t-error-updated-application": "Произошла ошибка при обновлении приложения",
  "t-application-version-file": "Файл версии приложения",
  "t-select-application-file": "Выбрать файл приложения",
  "t-placeholder-enter-application-version-name": "Введите имя версии",
  "t-error-application-version-required": "Название версии приложения является обязательным полем",
  "t-error-application-version-pattern": "Название версии приложения состоит из букв, цифр, подчеркиваний, точек и пробелов и не может начинаться или заканчиваться пробелом",
  "t-error-application-required": "Приложение является обязательным",
  "t-error-loading-application-version": "Произошла ошибка при загрузке версии приложения",
  "t-error-created-application-version": "Произошла ошибка при создании версии приложения",
  "t-error-updated-application-version": "Произошла ошибка при обновлении версии приложения",
  "t-select-certificate": "Выбрать сертификат",
  "t-select-certificate-to-signed": "Пожалуйста, выберите сертификат, который будет использоваться",
  "t-application-deleted-successfully": "Приложение {param} успешно удалено!",
  "t-error-deleting-application": "Произошла ошибка при удалении приложения",
  "t-application-choose-type": "Пожалуйста, выберите тип для загрузки {param}",
  "t-cannot-submit-repeatedly": "Нельзя повторно подавать",
  "t-activate-kiosk": "Активировать экранную монополию",
  "t-deactivate-kiosk": "Отключить киоск",
  "t-activate-kiosk-mode": "Включить режим полноэкранного отображения",
  "t-deactivate-kiosk-mode": "Отключить режим киоск",
  "t-actions": "операции",
  "t-device-bulk-upload": "Массовая загрузка устройств",
  "t-manufacturer-bulk-upload": "массовая загрузка производителя",
  "t-partner-bulk-upload": "массовая загрузка партнеров",
  "t-customer-bulk-upload": "массовая загрузка клиентов",
  "t-merchant-bulk-upload": "массовая загрузка торговцев",
  "t-store-bulk-upload": "Массовая загрузка магазина",
  "t-cortex-scanner-bulk-upload": "Массовая загрузка Cortex Scanner",
  "t-import-devices": "импорт устройств",
  "t-from-date": "Дата начала",
  "t-to-date": "конечная дата",
  "t-error-from-date-required": "Дата начала обязательна",
  "t-error-to-date-required": "Конечная дата обязательна",
  "t-state": "состояние",
  "t-delete-device-confirmation": "Подтверждение удаления устройства",
  "t-warning-to-delete-device": "Вы уверены, что хотите удалить устройство - {param}?",
  "t-warning-to-recover-device": "Вы уверены, что хотите снять предупреждение о демонтаже устройства?",
  "t-confirm-to-lock-device": "Вы уверены, что хотите разблокировать устройство?",
  "t-delete-activated-device": "Нельзя удалить активированное устройство",
  "t-cannot-delete-device-has-tid": "Нельзя удалять устройство с TID",
  "t-delete-device": "Удалить устройство",
  "t-add-transaction-param": "Добавить параметры транзакции",
  "t-add-transaction-param-version": "Добавление версии параметра транзакции",
  "t-search-transaction-param": "Параметры транзакции",
  "t-search-transaction-param-version": "Версия параметра транзакции",
  "t-transaction-param-version": "Версия параметра транзакции",
  "t-total-version": "общая версия",
  "t-add-partner": "Добавить партнера",
  "t-search-push": "Записи о рассылке",
  "t-search-partner": "Партнер",
  "t-add-customer": "Добавить клиента",
  "t-search-customer": "клиент",
  "t-edit-transaction-param": "редактировать параметры транзакции",
  "t-error": "ошибка",
  "t-error-loading-template": "Произошла ошибка при загрузке шаблона",
  "t-error-creating-template": "Произошла ошибка при создании шаблона",
  "t-error-update-template": "Произошла ошибка при обновлении шаблона",
  "t-invalid-json": "Недействительный JSON",
  "t-validate": "проверять",
  "t-template-updated-successfully": "Параметры транзакции {param} успешно обновлены!",
  "t-template-created-successfully": "Параметры транзакции {param} успешно созданы!",
  "t-enter-transaction-paramName": "Введите имя параметра транзакции",
  "t-required-transaction-name": "Название параметра транзакции является обязательным",
  "t-transaction-name-criteria": "Имя критерия транзакции может содержать только буквы, цифры, подчеркивания, точки и пробелы, и не может начинаться или заканчиваться пробелом",
  "t-action-code": "код действия",
  "t-required-transaction-action-code": "Код действия параметра транзакции является обязательным",
  "t-min-transaction-action-code": "Код операции параметров транзакции должен быть больше 200",
  "t-max-transaction-action-code": "Код операции параметра транзакции должен быть меньше 299",
  "t-pattern-transaction-action-code": "Код операции параметров транзакции может быть только цифрой",
  "t-enter-action-code": "Введите код действия",
  "t-transaction-deleted-successfully": "Транзакционные параметры {param} успешно удалены!",
  "t-error-deleting-transaction": "Произошла ошибка при удалении параметров транзакции",
  "t-error-deleting-transaction-child": "Под параметрами транзакции существует версия параметров транзакции. Пожалуйста, сначала удалите версию параметров транзакции!",
  "t-edit-transaction-param-version": "Редактирование версии параметра транзакции",
  "t-enter-transaction-param-version-name": "Введите название версии параметра транзакции",
  "t-error-transaction-param-version-required": "Версия параметра транзакции обязательна",
  "t-enter-intent-name": "Введите имя намерения",
  "t-enter-file-name": "Введите имя файла",
  "t-error-loading-template-param-version": "Произошла ошибка при загрузке версии параметров транзакции",
  "t-template-version-updated-successfully": "Версия параметров транзакции {param} успешно обновлена!",
  "t-template-version-created-successfully": "Версия параметров транзакции {param} успешно создана!",
  "t-error-creating-transaction-param-version": "Произошла ошибка при создании версии параметра транзакции",
  "t-error-updating-transaction-param-version": "Ошибка при обновлении версии параметра транзакции",
  "t-groups": "группа",
  "t-search-group": "группа",
  "t-add-group": "добавить группу",
  "t-edit-group": "редакционная группа",
  "t-search-group-device": "Устройства в поисковой группе",
  "t-group-name-required": "Имя группы обязательно",
  "t-group-name-pattern": "Имя группы может содержать только буквы, цифры, подчеркивания, точки и пробелы, и не может начинаться или заканчиваться пробелом",
  "t-enter-group-name": "Введите имя группы",
  "t-group-created-successfully": "Группа {param} успешно создана!",
  "t-error-group-created": "Произошла ошибка при создании группы",
  "t-group-updated-successfully": "Группа {param} успешно обновлена!",
  "t-error-group-updated": "Произошла ошибка при обновлении группы",
  "t-drag-device-to-group": "Перетащите устройство из доступного списка в выбранный список",
  "t-to": "до",
  "t-device-update": "обновление устройства",
  "t-updated-group-device-successfully": "Обновление группы {param} успешно!",
  "t-please-enter-name": "Пожалуйста, введите имя",
  "t-minimum-radius": "Минимальный радиус должен быть 50",
  "t-maximum-radius": "Максимальный радиус должен быть 9999",
  "t-duration-in-hours": "Продолжительность (в часах)",
  "t-please-enter-duration": "Пожалуйста, введите продолжительность",
  "t-minimum-duration": "Минимальная продолжительность должна быть 0",
  "t-maximum-duration": "Максимальная продолжительность должна составлять 72",
  "t-please-enter-action": "Просим ввести действие",
  "t-already-have-lock-action": "Если уже есть операция блокировки, то продолжительность предупреждающей операции должна быть меньше продолжительности блокировки, поскольку устройство прекратит выполнение любых дальнейших операций после операции блокировки",
  "t-add-locak-action-info": "Если вы добавляете действие блокировки, продолжительность должна быть больше самой последней продолжительности, потому что если выбрано действие блокировки, устройство прекратит выполнение любых дальнейших действий после этой операции",
  "t-invalid-warning-message": "Неверное предупреждающее сообщение",
  "t-invalid-action": "неверная операция",
  "t-invalid-duration": "Неверная продолжительность",
  "t-geo-fence-created-successfully": "Географическая ограда {param} успешно создана",
  "t-error-geo-fence-created": "Произошла ошибка при создании геозоны",
  "t-geo-fence-updated-successfully": "Географическая ограда {param} успешно обновлена",
  "t-error-geo-fence-updated": "Произошла ошибка при обновлении геозоны",
  "t-category-name": "название категории",
  "t-model-version-name": "название версии модели",
  "t-production-batch-name": "название партии производства",
  "t-sales-batch-name": "Название партии продаж",
  "t-select-valid-transaction-param": "Пожалуйста, выберите действительный параметр транзакции",
  "t-delete-transaction-param-version-confirmation": "Подтверждение удаления версии параметра транзакции",
  "t-warning-delete-transaction-param-version": "Вы уверены, что хотите удалить версию параметра транзакции - {param}?",
  "t-transaction-param-version-deleted-successfully": "Версия параметра транзакции {param} успешно удалена!",
  "t-error-deleting-transaction-param-version": "Произошла ошибка при удалении версии параметра транзакции",
  "t-please-check-values": "Просим ввести два значения",
  "t-check-value": "Проверочное значение",
  "t-error-check-value": "Произошла ошибка при проверке значения",
  "t-error-combine-keys": "Произошла ошибка при объединении ключей",
  "t-error-invalid-key-check": "Неверное значение KCV",
  "t-error-loading-checking-key": "Произошла ошибка при загрузке проверочного ключа ",
  "t-form-invalid-fill-mandatory": "Форма недействительна. Пожалуйста, заполните обязательные поля",
  "t-create-key": "создать ключ",
  "t-error-creating-key": "Произошла ошибка при создании ключа",
  "t-key-created-successfully": "Ключ {param} успешно создан!",
  "t-error-key-created": "Произошла ошибка при создании ключа",
  "t-add-key": "Добавить ключ",
  "t-edit-key": "редактировать ключ",
  "t-error-loading-created": "Произошла ошибка при загрузке ключа",
  "t-error-loading-algorithms": "Произошла ошибка при загрузке алгоритмов",
  "t-error-loading-partner": "Произошла ошибка при загрузке партнера",
  "t-error-loading-keys": "Произошла ошибка при загрузке ключей",
  "t-key-deleted-successfully": "Ключ {param} успешно удален!",
  "t-error-deleting-key": "Произошла ошибка при удалении ключа",
  "t-key-name-criteria": "Имя ключа может содержать только буквы, цифры и подчеркивания и не может начинаться или заканчиваться пробелом",
  "t-delete-key-confirmation": "Удаление ключа",
  "t-warning-delete-key": "Вы уверены, что хотите удалить ключ - {param}?",
  "t-zeros-not-allowed": "Не допускаются нули",
  "t-enter-key-name": "Введите имя ключа",
  "t-required-key-name": "Название ключа является обязательным полем",
  "t-enter-index": "Ввод индекса",
  "t-required-index": "Индекс является обязательным",
  "t-only-allowed-positive-integer-index": "Только допускается использование положительного целого числа",
  "t-index-max": "Значение индекса не может превышать 255",
  "t-select-date": "Выбрать дату",
  "t-select-customer": "Выбрать клиента",
  "t-select-merchant": "выбрать торговца",
  "t-select-store": "Выбрать магазин",
  "t-enter-key-group": "Введите группу ключей",
  "t-required-key-group": "Группа ключей является обязательным полем",
  "t-required-encrypted-key-under": "Зашифрованный ключ обязателен",
  "t-enter-key-value": "Введите значение ключа",
  "t-required-key-value-1": "Значение ключа 1 является обязательным",
  "t-key-kcv": "KCV",
  "t-key-bdk-lmk": "BDK / LMK",
  "t-key-zmk-lmk": "ZMK / LMK",
  "t-key-lmk": "ключ LMK",
  "t-required-key-kcv-1": "KCV1 является обязательным полем",
  "t-expiry-date-greater-than-current-date": "Дата истечения должна быть больше текущей даты",
  "t-error-loading-key": "Произошла ошибка при загрузке ключа",
  "t-partners": "партнеры",
  "t-keys ": " секретные ключи ",
  "t-key-name": "Название ключа",
  "t-is-required": "обязательное поле",
  "t-enter-kcv": "Ввод KCV",
  "t-final-key": "окончательный ключ",
  "t-full-apk": "Полный пакет",
  "t-patch-file": "Дифференциальный пакет",
  "t-application-certificate-message": "Согласно сертификату одобрения клиента отображается список оборудования",
  "t-error-patch-file-fail": "Не удалось сгенерировать дифференциальный пакет APK",
  "t-create-patch-file-success": "Успешно создан файл патча APK. Начата отправка. Перейдите к отчету о отправке для получения подробной информации о состоянии.",
  "t-create-patch-file": "Начать создание файла с разницей",
  "t-required-type": "Тип является обязательным полем",
  "t-required-version": "Версия является обязательным полем",
  "t-list-group": "Список групп",
  "t-list-device": "список устройств",
  "t-list": "список",
  "t-search-by-serial-number": "Поиск устройства по серийному номеру",
  "t-sort-devices": "Сортировать устройства",
  "t-uploading": "загрузка в процессе",
  "t-please-select-group-devices": "Пожалуйста, выберите группу или устройство",
  "t-error-push-group-empty": "В выбранной группе нет устройств!",
  "t-error-push-group-empty-by-model-version": "Выбранная группа не содержит устройств с версией модели {param}!",
  "t-error-push-group-store-empty": "В выбранной группе устройства не привязаны к магазинам!",
  "t-error-key-formation": "Ошибка формата ключа",
  "t-key-generation": "генерация ключа",
  "t-error-push-operation": "Некоторые устройства могут сталкиваться с проблемами при операции отправки",
  "t-error-push-device-inactive": "ПUSH-уведомление не удалось отправить, среди выбранных устройств есть неактивированные устройства",
  "t-error-push-device-abnormal": "ПUSH-уведомление не удалось отправить. Среди выбранных устройств есть устройства с аномальным состоянием",
  "t-push-completed-successfully": "Отправка {param} выполнена успешно",
  "t-push-batch-completed-successfully": "Сообщение {param} успешно отправлено. Просмотрите записи о рассылке для получения дополнительной информации",
  "t-push-device-certificate-unpush": "{param} был удален из партнеров и больше не будет получать уведомлений",
  "t-went-wrong": "произошла ошибка",
  "t-add-folder": "Добавить папку",
  "t-edit-folder": "редактировать папку",
  "t-required-file-name": "Имя файла является обязательным полем",
  "t-file-name-pattern": "Имя файла поддерживает только буквы, цифры, подчеркивание и тире",
  "t-select-file-type": "Выберите тип файла",
  "t-select-file": "Выбрать файл",
  "t-maximum-folder-file-size": "Размер файла не должен превышать 100 МБ",
  "t-error-loading-folder": "Произошла ошибка при загрузке папки",
  "t-error-creating-folder": "Произошла ошибка при создании папки",
  "t-error-updating-folder": "Произошла ошибка при обновлении папки",
  "t-folder-created-successfully": "Папка {param} успешно создана!",
  "t-folder-updated-successfully": "Папка {param} успешно обновлена!",
  "t-folder-deleted-successfully": "Папка {param} успешно удалена!",
  "t-required-folder-name": "Имя папки обязательно",
  "t-folder-name-pattern": "Название папки поддерживает только буквы, цифры, подчеркивание и тире",
  "t-select-partner": "выбрать партнера",
  "t-warning-delete-folder": "Вы уверены, что хотите удалить {param}?",
  "t-enter-folder-name": "Введите имя папки",
  "t-error-deleting-file": "Произошла ошибка при удалении файла",
  "t-file-deleted-successfully": "Файл {param} успешно удален!",
  "t-select-folder": "Пожалуйста, выберите действительную папку",
  "t-error-select-file": "Пожалуйста, выберите изображение, соответствующее одному из форматов {param}",
  "t-error-select-file-video": "Пожалуйста, выберите видео в одном из форматов {param}",
  "t-file-created-successfully": "Файл {param} успешно создан",
  "t-create-file": "Добавить файл",
  "t-create-folder": "добавить папку",
  "t-file-creation-failed": "Файл не создан",
  "t-file-updated-successfully": "Файл обновлен успешно",
  "t-file-updated-failed": "Произошла ошибка при обновлении файла",
  "t-warning-delete-file": "Вы уверены, что хотите удалить файл - {param}?",
  "t-add-file": "Добавить файл",
  "t-edit-file": "редактировать файл",
  "t-search-file": "файл",
  "t-search-advertisement": "реклама",
  "t-preview": "предварительный просмотр",
  "t-file-uploaded-failed": "Файл не был загружен",
  "t-file-uploaded-successfully": "Файл успешно загружен",
  "t-select-role": "выбрать роль",
  "t-add-role": "Добавить роль",
  "t-edit-role": "редактировать роль",
  "t-delete-role": "удалить роль",
  "t-delete-role-successfully": "Роль - {param} успешно удалена!",
  "t-widget-settings": "настройки виджета",
  "t-enter-role-name": "Введите имя роли",
  "t-required-role-name": "Имя роли является обязательным полем",
  "t-role-name-criteria": "Имя роли может содержать только буквы, цифры, подчеркивания, точки и пробелы, не может начинаться и заканчиваться пробелом",
  "t-role-created-successfully": "Роль {param} успешно создана!",
  "t-error-creating-role": "Произошла ошибка при создании роли",
  "t-role-updated-successfully": "Роль {param} успешно обновлена!",
  "t-error-updating-role": "Ошибка при обновлении роли",
  "t-permissions-updated-successfully": "Права обновлены успешно",
  "t-permissions-error-updated": "Произошла ошибка при обновлении разрешений",
  "t-permissions-updated-error": "Произошла ошибка при обновлении разрешений",
  "t-permission": "права",
  "t-browser-local-time": "Время локального браузера",
  "t-panel-name": "Название панели",
  "t-add-system-param": "Добавить системный параметр",
  "t-edit-system-param": "редактировать параметры системы",
  "t-search-system-param": "Параметры поисковой системы",
  "t-enter-system-param-name": "Введите название параметра системы",
  "t-required-system-param": "Название системного параметра является обязательным",
  "t-error-loading-system-param": "Произошла ошибка при загрузке системного параметра",
  "t-system-param-created-successfully": "Системный параметр {param} успешно создан!",
  "t-error-creating-system-param": "Произошла ошибка при создании системного параметра",
  "t-system-param-updated-successfully": "Системный параметр {param} успешно обновлен!",
  "t-error-updating-system-param": "Произошла ошибка при обновлении системного параметра",
  "t-system-param-deleted-successfully": "Системный параметр {param} успешно удален!",
  "t-error-deleting-system-param": "Произошла ошибка при удалении системного параметра",
  "t-enter-system-param-version-name": "Введите название версии системного параметра",
  "t-required-system-param-verion": "Версия системного параметра обязательна",
  "t-system-param-name-criteria": "Версия имени системного параметра может содержать только буквы, цифры, подчеркивания, точки и пробелы, и не может начинаться или заканчиваться пробелом",
  "t-add-system-param-version": "Добавление версии системного параметра",
  "t-edit-system-param-version": "Редактировать версию параметров системы",
  "t-error-loading-system-param-version": "Ошибка при загрузке версии системного параметра",
  "t-system-param-version-created-successfully": "Системный параметр версии {param} создан успешно!",
  "t-error-creating-system-param-version": "Ошибка при создании версии системного параметра",
  "t-search-system-param-version": "Версия параметра поисковой системы",
  "t-select-valid-system-param-version": "Выберите действительный параметр системы",
  "t-delete-system-param-version-confirmation": "Подтверждение удаления версии системного параметра",
  "t-warning-delete-system-param-version": "Вы уверены, что хотите удалить версию системного параметра - {param}?",
  "t-system-param-version-deleted-successfully": "Системный параметр версии {param} успешно удален!",
  "t-error-deleting-system-param-version": "Произошла ошибка при удалении версии системного параметра",
  "t-add-ui-settings": "Добавить настройки UI",
  "t-edit-ui-settings": "Редактировать настройки UI",
  "t-error-loading-ui-settings": "Произошла ошибка при загрузке настроек UI",
  "t-error-creating-ui-settings": "Произошла ошибка при создании настроек UI",
  "t-error-updating-ui-settings": "Произошла ошибка при обновлении настроек пользовательского интерфейса",
  "t-ui-settings-created": "UI настройки {param} созданы успешно!",
  "t-ui-settings-updated": "UI-настройки {param} успешно обновлены!",
  "t-enter-ui-settings-name": "Введите имя настроек UI",
  "t-required-ui-settings": "Название настроек UI является обязательным",
  "t-error-description-pattern": "Описание может содержать только буквы, цифры, подчеркивания, точки и пробелы, и не может начинаться или заканчиваться пробелом",
  "t-enter-ui-settings-description": "Описание настроек входного интерфейса",
  "t-required-ui-settings-action": "Действие настроек UI является обязательным",
  "t-file-type": "тип файла",
  "t-search-ui-settings": "Параметры интерфейса поиска",
  "t-error-deleting-ui-settings": "Произошла ошибка при удалении настроек UI",
  "t-ui-settings-deleted-successfully": "UI-настройки {param} успешно удалены!",
  "t-no-preview-available-zip": "ZIP-файл не доступен для предварительного просмотра",
  "t-no-preview-available-file": "Предварительный просмотр данного формата файла не поддерживается",
  "t-no-preview-available-video": "Видеофайл не доступен для предварительного просмотра",
  "t-browser-not-support-video-tags": "Ваш браузер не поддерживает теги видео",
  "t-preview-ui-settings": "Просмотр настроек UI",
  "t-download-failed": "Не удалось скачать",
  "t-add-ui-settings-version": "Добавление версии настроек UI",
  "t-pushable": "поддающийся толканию",
  "t-ui-settings-version": "Версия настроек UI",
  "t-please-select-valid-setting": "Пожалуйста, выберите действительное настройку",
  "t-warning-delete-ui-setting-version": "Вы уверены, что хотите удалить версию настроек UI - {param}?",
  "t-confirmation-delete-ui-settings-version": "Подтверждение удаления версии настроек UI",
  "t-ui-settings-version-deleted-successfully": "Версия настроек UI {param} успешно удалена!",
  "t-error-deleting-ui-settings-version": "Ошибка при удалении версии настроек UI",
  "t-enter-description": "Ввод описания",
  "t-required-ui-setting": "UI настройка является обязательным элементом",
  "t-ui-setting-version-file": "Файл версии настроек UI",
  "t-select-setting-file": "Выбрать файл настроек",
  "t-ui-setting-version": "Версия настроек UI",
  "t-add-ui-setting-version": "Добавление версии настроек UI",
  "t-edit-ui-setting-version": "Версия настроек редактирования UI",
  "t-file-resolution-does-not-match": "Разрешение файла не соответствует разрешению модели",
  "t-ui-setting-version-file-type": "Просим загрузить файл {param}",
  "t-error-loading-setting-version": "Произошла ошибка при загрузке версии настроек UI",
  "t-ui-setting-version-saved-successfully": "Версия настроек UI {param} успешно сохранена!",
  "t-ui-setting-version-updated-successfully": "Версия настроек UI {param} успешно обновлена!",
  "t-error-creating-ui-settings-version": "Произошла ошибка при создании версии настроек пользовательского интерфейса",
  "t-error-updating-ui-settings-version": "Ошибка при обновлении версии настроек пользовательского интерфейса",
  "t-delete-brand": "Удалить настройки HSM",
  "t-brand": "HSM настройка",
  "t-search-brand": "Поиск настроек HSM",
  "t-add-brand": "Добавить настройки HSM",
  "t-edit-brand": "Редактировать настройки HSM",
  "t-warning-delete-model": "Вы уверены, что хотите удалить модель - {param}?",
  "t-error-loading-brands": "Произошла ошибка при загрузке настроек HSM",
  "t-brand-created-successfully": "HSM {param} создан успешно!",
  "t-error-creating-brand": "Произошла ошибка при создании настроек HSM",
  "t-brand-updated-successfully": "HSM {param} обновлено успешно!",
  "t-error-updating-brand": "Произошла ошибка при обновлении настроек HSM",
  "t-brand-deleted-successfully": "HSM {param} успешно удалено!",
  "t-error-deleting-brand": "Произошла ошибка при удалении настроек HSM",
  "t-enter-brand-name": "Введите имя настройки HSM",
  "t-required-brand-name": "Название настройки HSM является обязательным",
  "t-edit-model": "редактировать модель",
  "t-error-updating-model": "Произошла ошибка при обновлении модели",
  "t-spec-url": "Стандартный URL",
  "t-enter-spec-url": "Введите спецификацию Url",
  "t-required-spec-url": "Введите действительный URL спецификации",
  "t-hsm-brand": "Hsm Brand",
  "t-add-interface": "Добавить интерфейс",
  "t-edit-interface": "редактировать интерфейс",
  "t-error-loading-interfaces": "Произошла ошибка при загрузке интерфейсов",
  "t-interface-created-successfully": "Интерфейс {param} успешно создан!",
  "t-error-creating-interface": "Произошла ошибка при создании интерфейса",
  "t-interface-updated-successfully": "Интерфейс {param} успешно обновлен!",
  "t-error-updating-interface": "Произошла ошибка при обновлении интерфейса",
  "t-search-interface": "Поисковый интерфейс",
  "t-enter-interface-name": "Введите имя интерфейса",
  "t-required-interface-name": "Имя интерфейса обязательно",
  "t-enter-user-name": "Введите имя пользователя",
  "t-required-user-name": "Введите действительное имя пользователя",
  "t-required-password": "Введите действительный пароль",
  "t-enter-primary-host": "Введите адрес главного хоста",
  "t-required-primary-host": "Введите действительный адрес хоста",
  "t-enter-primary-port": "Введите основной порт",
  "t-required-primary-port": "Введите действительный номер порта хоста",
  "t-enter-secondary-host": "Введите адрес вторичного хоста",
  "t-required-secondary-host": "Введите действительный адрес вторичного хоста",
  "t-enter-secondary-port": "Ввод вспомогательного порта",
  "t-required-secondary-port": "Введите действительный номер порта вспомогательного хоста",
  "t-is-enable": "Включен ли",
  "t-select-valid-interface": "Пожалуйста, выберите действительный интерфейс",
  "t-delete-interface-confirmation": "Подтверждение удаления интерфейса",
  "t-warning-delete-interface": "Вы уверены, что хотите удалить интерфейс - {param}?",
  "t-delete-interface": "Удалить интерфейс",
  "t-interface-deleted-successfully": "Интерфейс {param} успешно удален!",
  "t-error-deleting-interface": "Произошла ошибка при удалении интерфейса",
  "t-partner-name": "Название партнера",
  "t-enable-2FA": "Включить OTP",
  "t-enable-signature": "Включить подпись",
  "t-enable-remote-control": "дистанционное управление",
  "t-partner-setting": "Параметры партнера",
  "t-search-user": "пользователь",
  "t-add-user": "Добавить пользователя",
  "t-edit-user": "редактировать пользователя",
  "t-error-creating-user": "Произошла ошибка при создании пользователя",
  "t-user-created-successfully": "Пользователь {param} успешно создан!",
  "t-error-updating-user": "Произошла ошибка при обновлении пользователя",
  "t-required-email": "Почта является обязательным полем",
  "t-enter-correct-email": "Введите правильный формат электронной почты",
  "t-enter-email": "Введите электронную почту",
  "t-enter-first-name": "Введите имя",
  "t-required-first-name": "Имя является обязательным полем",
  "t-enter-last-name": "Введите фамилию",
  "t-current-password": "текущий пароль",
  "t-new-password": "Новый пароль",
  "t-please-fill-all-mandatory-fields": "Просим заполнить все обязательные поля",
  "t-user-password-changed-successfully": "Пароль пользователя успешно изменен. Просим вас снова войти в систему!",
  "t-error-changing-user-password": "Текущая пароль неверна или произошла ошибка при изменении пароля пользователя",
  "t-user-profile": "Профиль пользователя",
  "t-user-avatar-modified-successfully": "Пользовательский аватар изменен успешно!",
  "t-user-avatar-modified-failed": "Не удалось изменить аватар пользователя!",
  "t-user-avatar-deletion-successfully": "Пользовательский аватар удален успешно!",
  "t-user-avatar-deletion-failed": "Не удалось удалить аватар пользователя!",
  "t-user-avatar-not-exist": "Аватар пользователя не существует!",
  "t-user-avatar-select-failed": "Пожалуйста, выберите аватар пользователя!",
  "t-roles": "роль",
  "t-error-length-password": "Длина пароля должна быть не менее ",
  "t-error-minimum-length-password": "Длина пароля должна быть не менее 6 символов",
  "t-error-maximum-length-password": "Длина пароля не должна превышать 32 символов",
  "t-error-password-criteria": "Формат пароля должен быть комбинацией цифр и букв",
  "t-enter-confirm-password": "Введите подтверждающий пароль",
  "t-warning-reset-password": "Вы уверены, что хотите сбросить пароль?",
  "t-sent-reset-password": "Перезагрузка пароля электронной почты отправлена успешно.",
  "t-resend-token-email": "Отправить QR-код активации",
  "t-resend-email-successfully": "Пользователь успешно отправил электронное письмо!",
  "t-error-resend-email": "Пользователь не смог отправить электронное письмо!",
  "t-delete-user": "удалить пользователя",
  "t-cannot-delete-activated-user": "Невозможно удалить активированного пользователя",
  "t-user-deactivated-successfully": "Пользователь был отключен успешно",
  "t-user-activated-successfully": "Пользователь успешно активирован",
  "t-reset-password-sent-successfully": "Электронное письмо для сброса пароля отправлено успешно",
  "t-user-activated-token-successfully": "Пользователь успешно активировал мобильный токен!",
  "t-user-updated-successfully": "Пользователь {param} успешно обновлен!",
  "t-warning-delete-user": "Вы уверены, что хотите удалить пользователя - {param1} {param2}?",
  "t-delete-user-confirmation": "Подтверждение удаления пользователя",
  "t-token-replaced-successfully": "Пользователь успешно заменил мобильный токен!",
  "t-error-token-replace": "Пользователь не смог заменить мобильный токен! ",
  "t-error-token-activation": "Пользователь не смог активировать мобильный токен! ",
  "t-group-deleted-successfully": "Группа {param} успешно удалена!",
  "t-error-deleting-group": "Произошла ошибка при удалении группы",
  "t-delete-partner": "Удалить партнера",
  "t-partner-deleted-successfully": "Партнер {param} успешно удален!",
  "t-error-deleted-partner": "Произошла ошибка при удалении партнера",
  "t-edit-partner": "редактировать партнера",
  "t-error-loading-partners": "Произошла ошибка при загрузке партнеров",
  "t-partner-created-successfully": "Партнер {param} успешно создан!",
  "t-error-created-partner": "Произошла ошибка при создании партнера",
  "t-partner-updated-successfully": "Партнер {param} успешно обновлен!",
  "t-error-updated-partner": "Ошибка при обновлении партнера",
  "t-required-continent-name": "Название континента является обязательным",
  "t-required-region-name": "Название региона является обязательным полем",
  "t-required-country-name": "Название страны является обязательным полем",
  "t-select-continent": "Выбрать континент",
  "t-select-region": "Выбрать регион",
  "t-error-loading-countries": "Произошла ошибка при загрузке стран",
  "t-enter-partner-name": "Введите имя партнера",
  "t-required-partner-name": "Название партнера является обязательным полем",
  "t-partner-name-criteria": "Имя партнера может содержать только буквы, цифры, подчеркивания, точки и пробелы, не может начинаться и заканчиваться пробелом",
  "t-enter-phone-no": "Введите номер телефона",
  "t-required-valid-phone-no": "Введите действительный номер телефона",
  "t-enter-email-address": "Введите адрес электронной почты",
  "t-required-valid-email-address": "Введите действительный адрес электронной почты",
  "t-enter-address": "Ввести адрес",
  "t-error-enter-valid-address": "Адрес допускает только ввод прописных и строчных букв, цифр и дефисов",
  "t-required-parent-partner": "Введите родительского партнера",
  "t-edit-customer": "редактировать клиента",
  "t-enter-customer-name": "Введите имя клиента",
  "t-required-customer-name": "Название клиента является обязательным полем",
  "t-required-customer": "Клиент является обязательным полем",
  "t-customer-name-criteria": "Имя клиента может содержать только буквы, цифры, подчеркивания, точки и пробелы, не может начинаться и заканчиваться пробелом",
  "t-error-loading-customers": "Произошла ошибка при загрузке клиентов",
  "t-customer-created-successfully": "Клиент {param} успешно создан!",
  "t-error-created-customer": "Произошла ошибка при создании клиента",
  "t-customer-updated-successfully": "Клиент {param} успешно обновлен!",
  "t-error-updated-customer": "Произошла ошибка при обновлении клиента",
  "t-warning-delete-customer": "Вы уверены, что хотите удалить клиента - {param}?",
  "t-warning-delete-merchant": "Вы уверены, что хотите удалить торговца - {param}?",
  "t-warning-delete-store": "Вы уверены, что хотите удалить магазин - {param}?",
  "t-delete-customer": "Удалить клиента",
  "t-customer-deleted-successfully": "Клиент {param} успешно удален!",
  "t-error-deleted-customer": "Произошла ошибка при удалении клиента",
  "t-add-merchant": "Добавить торговца",
  "t-edit-merchant": "редактировать торговца",
  "t-enter-mid": "Ввод MID",
  "t-error-loading-merchant": "Произошла ошибка при загрузке торговца",
  "t-merchant-created-successfully": "Мерчант {param} успешно создан!",
  "t-error-created-merchant": "Произошла ошибка при создании торговца",
  "t-merchant-updated-successfully": "Продавец {param} успешно обновлен!",
  "t-error-updated-merchant": "Произошла ошибка при обновлении торговца",
  "t-enter-merchant-name": "Введите название торговца",
  "t-required-merchant-name": "Название торговца является обязательным полем",
  "t-required-merchant": "Мерчант является обязательным полем",
  "t-merchant-name-criteria": "Название торговца может содержать только буквы, цифры, подчеркивания, точки и пробелы, не может начинаться и заканчиваться пробелом",
  "t-merchant-deleted-successfully": "Мерчант {param} успешно удален!",
  "t-error-deleted-merchant": "Произошла ошибка при удалении торговца",
  "t-delete-merchant": "удалить торговца",
  "t-search-merchant": "Мерчант",
  "t-merchant-name": "название торговца",
  "t-error-loading-store": "Произошла ошибка при загрузке магазина",
  "t-store-created-successfully": "Магазин {param} успешно создан!",
  "t-error-created-store": "Произошла ошибка при создании магазина",
  "t-store-updated-successfully": "Магазин {param} успешно обновлен!",
  "t-error-updated-store": "Произошла ошибка при обновлении магазина",
  "t-enter-store-name": "Введите название магазина",
  "t-required-valid-customer": "Пожалуйста, выберите действительного клиента",
  "t-required-valid-merchant": "Пожалуйста, выберите действительного торговца",
  "t-required-store-name": "Название магазина является обязательным полем",
  "t-store-name-criteria": "Название магазина может содержать только буквы, цифры, подчеркивания, точки и пробелы, не может начинаться и заканчиваться пробелом",
  "t-search-store": "магазин",
  "t-add-store": "Добавить магазин",
  "t-edit-store": "редактировать магазин",
  "t-required-valid-store": "Пожалуйста, выберите действительный магазин",
  "t-delete-store": "Удалить магазин",
  "t-store-deleted-successfully": "Магазин {param} успешно удален!",
  "t-deleting-store": "Удаление магазина",
  "t-error-store-deleted": "Произошла ошибка при удалении магазина",
  "t-manufacturer-created-successfully": "Производитель {param} успешно создан!",
  "t-error-manufacturer-created": "Произошла ошибка при создании производителя",
  "t-manufacturer-updated-successfully": "Производитель {param} успешно обновлен!",
  "t-error-manufacturer-updated": "Произошла ошибка при обновлении производителя",
  "t-manufacturer-deleted-successfully": "Производитель {param} успешно удален!",
  "t-error-manufacturer-deleted": "Произошла ошибка при удалении производителя",
  "t-error-model-pattern": "Название модели должно состоять из букв, цифр, подчеркиваний, точек и пробелов и не должно начинаться или заканчиваться пробелом",
  "t-error-model-version-pattern": "Название версии модели должно состоять из букв, цифр, подчеркиваний, точек и пробелов и не должно начинаться или заканчиваться пробелом",
  "t-error-format-required": "Формат является обязательным полем",
  "t-model-version-created-successfully": "Модель версии {param} успешно создана!",
  "t-model-version-updated-successfully": "Версия модели {param} успешно обновлена!",
  "t-error-creating-model-version": "Произошла ошибка при создании версии модели",
  "t-error-updated-model-version": "Произошла ошибка при обновлении версии модели",
  "t-error-deleted-model": "Произошла ошибка при удалении модели",
  "t-error-deleted-model-version": "Произошла ошибка при удалении версии модели",
  "t-error-deleting-transaction-param": "Произошла ошибка при удалении параметра транзакции",
  "t-transaction-param-deleted-successfully": "Параметр транзакции {param} успешно удален!",
  "t-required-valid-group": "Пожалуйста, выберите действительную группу",
  "t-firmware-deleted-successfully": "Фирмварь {param} успешно удалена!",
  "t-error-deleting-firmware": "Произошла ошибка при удалении прошивки",
  "t-required-valid-firmware": "Пожалуйста, выберите действительную прошивку",
  "t-firmware-version-deleted-successfully": "Версия прошивки {param} успешно удалена!",
  "t-error-deleting-firmwareversion": "Произошла ошибка при удалении версии прошивки",
  "t-download-firmware": "загрузка прошивки",
  "t-add-firmware-version": "Добавить версию прошивки",
  "t-edit-firmware-version": "редактировать версию прошивки",
  "t-firmware-name": "Название прошивки",
  "t-search-firmware": "Прошивка",
  "t-add-firmware": "Добавить прошивку",
  "t-edit-firmware": "редактировать прошивку",
  "t-enter-firmware-name": "Введите название прошивки",
  "t-required-firmware-name": "Название прошивки является обязательным",
  "t-firmware-name-criteria": "Имя прошивки должно состоять из букв, цифр, подчеркиваний, точек и пробелов и не должно начинаться или заканчиваться пробелом",
  "t-error-loading-firmware": "Произошла ошибка при загрузке прошивки",
  "t-firmware-created-successfully": "Фирмварь {param} успешно создана!",
  "t-error-creating-firmware": "Произошла ошибка при создании прошивки",
  "t-firmware-updated-successfully": "Прошивка {param} успешно обновлена!",
  "t-error-updating-firmware": "Произошла ошибка при обновлении прошивки",
  "t-firmware-file": "Прошивочный файл",
  "t-select-firmware-file": "Выберите файл прошивки",
  "t-firmware-version-name": "Название версии прошивки",
  "t-required-version-name": "Название версии является обязательным полем",
  "t-required-firmware": "Фирмовое ПО является обязательным",
  "t-error-firmware-version-pattern": "Название версии прошивки должно состоять из букв, цифр, подчеркиваний, точек, тире и пробелов и не должно начинаться или заканчиваться пробелом",
  "t-error-loading-firmware-version": "Произошла ошибка при загрузке версии прошивки",
  "t-firmware-version-created-successfully": "Версия прошивки {param} успешно создана!",
  "t-error-creating-firmware-version": "Произошла ошибка при создании версии прошивки",
  "t-firmware-version-updated-successfully": "Прошивка версии {param} успешно обновлена!",
  "t-error-updating-firmware-version": "Произошла ошибка при обновлении версии прошивки",
  "t-manufacturer-consists": "Название производителя должно состоять из букв, цифр, подчеркиваний, точек и пробелов и не должно начинаться или заканчиваться пробелом",
  "t-ui-settings-consists": "Название настроек UI должно состоять из букв, цифр, подчеркивания, точек и пробелов и не должно начинаться или заканчиваться пробелом",
  "t-log-capture-title-types": "Типы журналов",
  "t-log-capture-title-logs": "Журналы",
  "t-log-capture-title-main": "Основной журнал",
  "t-log-capture-title-kernel": "Ядро журнала",
  "t-btn-stop": "остановить",
  "t-btn-capture": "захватить",
  "t-log-type": "Тип журнала",
  "t-log-type-main": "Основной журнал",
  "t-log-type-kernel": "Ядро журнала",
  "t-create-log-capture-event": "Задача по захвату журнала создана успешно!",
  "t-search-logs": "журналы",
  "t-error-creating-log-capture": "Произошла ошибка при захвате журнала",
  "t-log-capture-process": "Происходит сбор логов",
  "t-stop-log-capture-event": "Остановить сбор логов!",
  "t-error-stop-log-capture-event": "Произошла ошибка при остановке захвата журнала!",
  "t-stop-log-capture-info": "Задача по захвату журнала завершена!",
  "t-error-enter-log-capture": "Проверьте, заполнены ли серийный номер устройства или тип журнала!",
  "t-time-limit": "время ограничение",
  "t-download-log": "загрузочный журнал",
  "t-file-download-failed": "Файл не скачался!",
  "t-error-log-forbidden": "Получение журнала еще не завершено. Пожалуйста, подождите!",
  "t-error-deleting-log-file": "Произошла ошибка при удалении файла журнала!",
  "t-error-show-detail-log": "Произошла ошибка при просмотре подробной информации!",
  "t-delete-log-file": "Журнальный файл {param} успешно удален!",
  "t-detail-log-title": "Журнальный файл: {param} {date}",
  "t-add-log-capture-event": "Добавление события захвата журнала",
  "t-ap": "AP",
  "t-sp": "СП",
  "t-general-all": "все",
  "t-to-include": "включать",
  "t-otp-password": "Пароль OTP",
  "t-select-entity": "выбрать сущность",
  "t-other-settings": "Другие настройки",
  "t-metadata": "метаданные",
  "t-available-servers": "Доступные серверы",
  "t-service": "услуга ",
  "t-url": "URL",
  "t-download-progress": "Процесс загрузки",
  "t-send": "отправлять",
  "t-enter-email-instructions-to-tou": "Введите свою электронную почту, инструкции будут отправлены вам!",
  "t-search-message": "сообщение",
  "t-enter-message": "Ввести сообщение",
  "t-send-message": "отправить сообщение",
  "t-message-mgmt": "Управление сообщениями",
  "t-required-duration": "Продолжительность является обязательным полем",
  "t-required-message": "Сообщение является обязательным полем",
  "t-message-sent": "Сообщение отправлено успешно",
  "t-ad-planner": "рекламный плановик",
  "t-add-ad-planner": "Добавить рекламный план",
  "t-search-ad-planner": "Рекламный план",
  "t-enter-planner-name": "Введите название рекламного плана",
  "t-required-planner-name": "Название рекламного плана является обязательным полем",
  "t-add-advertisement": "Добавить рекламу",
  "t-edit-advertisement": "редактировать рекламу",
  "t-error-end-time-greater-than-start": "Время окончания должно быть больше времени начала",
  "t-advertisement-updated-successfully": "Реклама {param} успешно обновлена!",
  "t-error-updating-advertisement": "Произошла ошибка при обновлении рекламы",
  "t-advertisement-created-successfully": "Реклама {param} успешно создана!",
  "t-error-creating-advertisement": "Произошла ошибка при создании рекламы",
  "t-error-loading-advertisement": "Произошла ошибка при загрузке рекламы",
  "t-add-planner": "Добавить рекламный план",
  "t-edit-planner": "редактировать рекламный план",
  "t-select-planner": "Пожалуйста, выберите действительный рекламный план",
  "t-error-loading-planner": "Произошла ошибка при загрузке рекламного плана",
  "t-planner-created-successfully": "Рекламный план {param} успешно создан!",
  "t-error-created-planner": "Произошла ошибка при создании рекламного плана",
  "t-planner-updated-successfully": "Рекламный план {param} успешно обновлен!",
  "t-error-updated-planner": "Произошла ошибка при обновлении рекламного плана",
  "t-delete-advertisement": "удалить рекламу",
  "t-advertisement-deleted-successfully": "Реклама {param} успешно удалена!",
  "t-error-deleting-advertisement": "Произошла ошибка при удалении рекламы",
  "t-advertisement-expired": "Реклама истекла",
  "t-advertisement-end-time": "Время окончания должно быть больше текущего времени",
  "t-planner-deleted-successfully": "Рекламный план {param} успешно удален!",
  "t-error-deleting-planner": "Произошла ошибка при удалении рекламного плана",
  "t-warning-delete-advertisement": "Вы уверены, что хотите удалить рекламу - {param}?",
  "t-warning-delete-planner": "Вы уверены, что хотите удалить рекламный план - {param}?",
  "t-select-ads-start-date": "Выберите дату начала рекламы",
  "t-select-ads-end-date": "Выбрать дату окончания рекламы",
  "t-ads-name": "Название рекламы",
  "t-ads-name-required": "Название рекламы является обязательным полем",
  "t-enter-ad-name": "Введите название рекламы",
  "t-ads-start-required": "Дата начала рекламы является обязательным полем",
  "t-ads-end-required": "Дата окончания рекламы обязательна для заполнения",
  "t-enter-detail-url": "Введите URL с подробностями",
  "t-detail-url-required": "URL детали обязателен",
  "t-start-dete": "Дата и время начала",
  "t-end-date": "Дата и время окончания",
  "t-message-name-required": "Имя сообщения является обязательным полем",
  "t-required-message-type": "Тип сообщения является обязательным полем",
  "t-message-content-required": "Сообщение является обязательным",
  "t-placeholder-message-text": "Здесь напишите текстовое сообщение...",
  "t-select-execute-date": "Выбрать дату выполнения",
  "t-select-expired-date": "Выбрать дату истечения срока",
  "t-select-executed-date": "Выберите дату выполнения",
  "t-expiration-time-greater-than-execution-time": "Время истечения срока должно быть больше времени выполнения",
  "t-execution-time-less-than-current-time": "Время выполнения должно быть больше текущего времени",
  "t-expiration-time-less-than-current-time": "Время истечения должно быть больше текущего времени",
  "t-message-created-successfully": "Сообщение {param} успешно создано!",
  "t-error-creating-message": "Произошла ошибка при создании сообщения",
  "t-message-updated-successfully": "Сообщение {param} успешно обновлено!",
  "t-error-updated-message": "Произошла ошибка при обновлении сообщения",
  "t-folders": "папки",
  "t-available-files": "Доступные файлы",
  "t-selected-files": "Выбранные файлы",
  "t-start-remote-control": "Запуск дистанционного управления",
  "t-stop-remote-control": "остановить дистанционное управление",
  "t-account-not-exist": "Входящий аккаунт не существует. Проверьте внимательно.",
  "t-search-Keys": "Поиск",
  "t-details": "подробная информация",
  "t-transaction-id": "Идентификатор транзакции",
  "t-payment-certificates": "TLS сертификаты",
  "t-payment-application-certificates": "TLS сертификаты",
  "t-add-payment-application-certificate": "Добавить сертификат TLS",
  "t-search-certificate": "сертификат",
  "t-add-certificate": "Добавить сертификат",
  "t-edit-certificate": "редактировать сертификат",
  "t-enter-name": "Введите имя",
  "t-set-password": "Установить пароль",
  "t-enter-password": "Введите пароль",
  "t-enter-new-password": "Введите новый пароль",
  "t-confirm-new-password": "Подтвердить новый пароль",
  "t-private-key-password": "пароль от закрытого ключа",
  "t-certificateLevel-1": "1-й уровень сертификата",
  "t-certificateLevel-2": "сертификат уровня 2",
  "t-level1-certificates": "Первый уровень сертификатов",
  "t-please-select-customer": "Пожалуйста, выберите клиента",
  "t-please-select-certificate": "Пожалуйста, выберите сертификат",
  "t-please-select-common-name": "Пожалуйста, введите общее название",
  "t-please-select-org-unit": "Просим ввести организационную единицу",
  "t-please-select-org-name": "Просим ввести название организации",
  "t-please-select-city": "Просим ввести город",
  "t-please-select-state": "Просим ввести штат/провинцию",
  "t-please-select-country": "Просим ввести страну",
  "t-please-select-rsa-key": "Пожалуйста, выберите ключ RSA",
  "t-please-enter-password": "Пожалуйста, введите пароль",
  "t-prohibit-enter-space": "Запрещено вводить пробелы.",
  "t-error-maximum-length-key-password": "Максимальная длина пароля составляет 10 символов",
  "t-error-confirm-password-equal-new-password": "Подтверждающий пароль должен быть таким же, как новый пароль",
  "t-signed-l2-certificate": "Подписанный сертификат уровня 2",
  "t-cert-name": "Название сертификата",
  "t-enter-common-name": "Введите общее название",
  "t-enter-org-unit": "Введите организационную единицу",
  "t-enter-org": "вводить.орг",
  "t-enter-city": "ввести город",
  "t-enter-state": "Введите штат / провинцию",
  "t-enter-country": "ввести страну",
  "t-certificate-updated-successfully": "Сертификат {param} успешно обновлен",
  "t-certificate-created-successfully": "Сертификат {param} успешно создан",
  "t-reover-tamper-status": "Вы уверены, что хотите снять предупреждение о вскрытии устройства? ",
  "t-recover-tamper-success": "Предупреждение о вскрытии устройства было успешно отправлено на устройство",
  "t-recover-tamper-error": "Запрос на отправку предупреждения о снятии устройства с защитного механизма не удался",
  "t-recover-key-error": "Запрос на инициализацию ключа устройства для отправки не удался",
  "t-add-message": "Добавить сообщение",
  "t-select-message": "Пожалуйста, выберите действительного партнера",
  "t-enter-message-name": "Введите название сообщения",
  "t-warning-delete-messageList": "Вы уверены, что хотите удалить сообщение - {param}?",
  "t-messageList-deleted-successfully": "Сообщение {param} успешно удалено!",
  "t-error-deleting-messagelist": "Не удалось удалить список сообщений",
  "t-error-loading-message": "Произошла ошибка при загрузке сообщения",
  "t-create-message": "Добавить сообщение",
  "t-edit-message": "редактировать сообщение",
  "t-key-bulk-upload": "массовая загрузка ключей",
  "t-import-key": "импортный ключ",
  "t-update-type": "Тип обновления",
  "t-full": "целый пакет",
  "t-patch": "дифференциальный пакет",
  "t-warning-delete-certificate": "Вы уверены, что хотите удалить сертификат - {param}?",
  "t-cert-mgmt": "Управление сертификатами",
  "t-upload-certificate": "загрузка сертификата",
  "t-create-certificate": "создать сертификат",
  "t-error-deleting-certificate": "Произошла ошибка при удалении сертификата",
  "t-certificate-deleted-successfully": "Сертификат {param} успешно удален!",
  "t-upload-successfully": "Загрузка файла прошла успешно!",
  "t-upload-failed": "Не удалось загрузить файл!",
  "t-certificateLevel": "Уровень сертификата",
  "t-signature-success": "Успешно сгенерирован сертификат",
  "t-error-creating-certificate": "Произошла ошибка при создании сертификата",
  "t-error-updating-certificate": "Произошла ошибка при обновлении сертификата",
  "t-import-customer": "импорт клиента",
  "t-import-manufacturer": "Импорт производителя",
  "t-import-partner": "импорт партнера",
  "t-import-merchant": "импорт торговца",
  "t-import-store": "импортный магазин",
  "t-search-folder": "папка",
  "t-timeline-device": "жизненный цикл",
  "t-login-confirm-partner": "Обнаружено вход в систему партнера. Вы хотите выйти из системы партнера или продолжить?",
  "t-created-date": "Дата создания",
  "t-created-by": "создатель",
  "t-created-time": "время создания",
  "t-partner-open-2nd-signature": "Партнер включил вторую подпись",
  "t-signed-by-feitian": "Подписано сертификатом Фэйтянь",
  "t-add-profile": "Добавить файл инициализации терминала",
  "t-edit-profile": "Редактирование файла инициализации терминала",
  "t-delete-profile": "Удалить файл инициализации терминала",
  "t-profile-name": "Название файла инициализации терминала",
  "t-partnerName": "Название партнера",
  "t-modelVersionName": "Название версии модели",
  "t-profile-name-required": "Имя файла инициализации терминала является обязательным полем",
  "t-profile-created": "Файл инициализации терминала {param} успешно создан!",
  "t-profile-updated": "Файл инициализации терминала {param} успешно обновлен!",
  "t-error-creating-profile": "Произошла ошибка при создании файла инициализации терминала",
  "t-error-updating-profile": "Произошла ошибка при обновлении файла инициализации терминала",
  "t-enable-profile-success": "Успешное включение файла инициализации терминала",
  "t-enable-profile-close": "Успешное закрытие файла инициализации терминала",
  "t-select-least-operation": "Пожалуйста, выберите хотя бы одну операцию",
  "t-select-identical-application": "Вы выбрали повторяющееся приложение",
  "t-enable-profile-fail": "Не удалось включить файл инициализации терминала",
  "t-delete-profile-error": "Файл инициализации терминала включен и не может быть удален!",
  "t-search-profile": "Файл инициализации терминала",
  "t-warning-delete-profile": "Вы уверены, что хотите удалить файл инициализации терминала - {param}?",
  "t-delete-profile-confirmation": "Подтверждение удаления файла инициализации терминала",
  "t-profile-deleted": "Файл инициализации терминала {param} успешно удален!",
  "t-cancel-push": "Отменить отправку",
  "t-abort": "отменить",
  "t-warning-delete-geo-fence": "Вы уверены, что хотите удалить геозону - {param}?",
  "t-geoFence-deleted-successfully": "Географический забор удален успешно!",
  "t-error-deleting-geoFence-version": "Произошла ошибка при удалении геозоны",
  "t-add-geo-fencing": "Добавить геозону",
  "t-edit-geo-fencing": "редактировать географическую оградку",
  "t-search-geo-fencing": "географическая оградка",
  "t-save": "сохранить",
  "t-delete-file": "удалить файл",
  "t-warning-message": "Предупреждающее сообщение",
  "t-warning-add-block-device": "Если выбрана операция блокировки, устройство не будет выполнять никаких дальнейших действий после этой операции",
  "t-confirm-block-device": "Подтвердить блокировку устройства",
  "t-proceed": "продолжать",
  "t-fix-report": "статическая отчетность",
  "t-start-time": "время начала",
  "t-end-time": "время окончания",
  "t-select-start-time": "Выберите дату начала",
  "t-select-end-time": "Выбрать дату окончания",
  "t-error-exporting-report": "Не удалось экспортировать отчет ",
  "t-report-mgmt": "Управление отчетностью",
  "t-select-all": "Выбрать все",
  "t-deselect-all": "Отменить выбор всех",
  "t-transaction-version-information": "STORM автоматически интегрировал TID и MID в Json в соответствии с серийным номером, поэтому вам не нужно устанавливать TID и MID в Json. Если вы все же установите TID и MID, мы будем использовать вашу версию",
  "t-support-mgmt": "Поддержка управления",
  "t-tickets-updated-successfully": "Заказ на работу успешно обновлен!",
  "t-error-push-ui-group-empty": "В выбранной группе присутствуют устройства разных версий моделей!",
  "t-warning-to-delete-push-event": "Вы уверены, что хотите удалить событие рассылки?",
  "t-push-event-deleted-successfully": "Успешно удалена событие отправки!",
  "t-application-push-by-group-error": "{param} еще не привязан к уровню клиента. Пожалуйста, сначала выполните привязку!",
  "t-merchant-redirect-confirm": "Хотите ли вы перенаправиться на портал продавца? Или продолжить использовать STORM?",
  "t-merchant-redirect-title": "Перенаправление на портал продавца",
  "t-merchant-redirect": "перенаправление",
  "t-abnormal-device": "Аномальное устройство",
  "t-log-download-failed": "Не удалось получить журнал и скачать",
  "t-log-deleting-error": "Если получение журнала не удалось, должно появиться сообщение о том, что получение журнала не удалось и его нельзя удалить",
  "t-account-exception": "Ваш счет находится в аномальном состоянии. Пожалуйста, свяжитесь с администратором!",
  "t-signed": "подпись",
  "t-unsigned": "не подписанный",
  "t-select-valid-partner": "Пожалуйста, выберите действительного партнера",
  "t-password-mismatch": "Пароль не соответствует",
  "t-support-gms": "Поддержка Gms",
  "t-search-repository": "репозиторий",
  "t-repository": "хранилище",
  "t-add-repository": "Добавить репозиторий",
  "t-edit-repository": "редактировать репозиторий",
  "t-error-loading-repository": "Произошла ошибка при загрузке репозитория",
  "t-repository-updated-successfully": "Хранилище {param} успешно обновлено!",
  "t-error-updating-repository": "Произошла ошибка при обновлении репозитория",
  "t-repository-created-successfully": "Хранилище {param} успешно создано!",
  "t-error-creating-repository": "Произошла ошибка при создании репозитория",
  "t-error-deleting-repository": "Произошла ошибка при удалении репозитория",
  "t-repository-name-criteria": "Имя репозитория может содержать только буквы, цифры, подчеркивания, точки и пробелы, не может начинаться и заканчиваться пробелом",
  "t-required-repository-name": "Название репозитория обязательно",
  "t-enter-repository-name": "Введите имя репозитория",
  "t-add-cloud-message": "Добавить облачное сообщение",
  "t-required-valid-cloud-message": "Пожалуйста, выберите действительное облачное сообщение",
  "t-required-cloud-name": "Название является обязательным полем",
  "t-token": "токен",
  "t-repository-deleted-successfully": "Хранилище {param} успешно удалено!",
  "t-cloud-message-deleted-successfully": "Облачное сообщение {param} успешно удалено!",
  "t-search-cloud-message": "облачное сообщение",
  "t-cloud-name-criteria": "Имя облачного сообщения может содержать только буквы, цифры, подчеркивания, точки и пробелы, не может начинаться и заканчиваться пробелом",
  "t-enter-token": "входной токен",
  "t-edit-cloud-message": "редактировать облачное сообщение",
  "t-error-loading-cloud-message": "Произошла ошибка при загрузке облачных сообщений",
  "t-cloud-message-updated-successfully": "Обновление облачного сообщения {param} успешно!",
  "t-error-loading-updating-cloud-message": "Произошла ошибка при обновлении облачного сообщения",
  "t-cloud-message-created-successfully": "Облачное сообщение {param} создано успешно!",
  "t-error-loading-creating-cloud-message": "Произошла ошибка при создании облачного сообщения",
  "t-error-deleting-cloud-message": "Произошла ошибка при удалении облачного сообщения",
  "t-push-setting": "Настройки push",
  "t-error-deleting-folder": "Произошла ошибка при удалении папки",
  "t-cortex-scanner-import": "Импорт Cortex Scanner",
  "t-import-cortex-scanner": "Импорт Cortex Scanner",
  "t-import-cortex-scanner-success": "Файл импортирован успешно!",
  "t-system-info": "Системная информация",
  "t-payment-kernel": "ядро платежей",
  "t-device-configuration": "устройство.конфигурация",
  "t-functional-info": "функциональная информация",
  "t-push-install-type": "Тип установки",
  "t-automatic-upgrade": "Автоматическое обновление",
  "t-push-transaction-detail": "продвижение",
  "t-push-is-mobile-traffic": "Используется ли мобильный трафик",
  "t-push-start-time": "время начала",
  "t-push-end-time": "время окончания",
  "t-push-details": "подробности рассылки",
  "t-activated-kiosk-mode": "Активирован режим киоск",
  "t-unActivated-kiosk-mode": "Отключить режим полноэкранного отображения",
  "t-push-abort-successfully": "Отмена отправки прошла успешно!",
  "t-error-push-abort": "Произошла ошибка при отмене отправки",
  "t-push-event": "Плановая задача",
  "t-add-push-event": "Добавление планируемой задачи",
  "t-edit-push-event": "Редактирование планируемой задачи",
  "t-required-event-name": "Название планируемой задачи является обязательным полем",
  "t-event-name-pattern": "Имя планируемой задачи может содержать только буквы, цифры, подчеркивания, точки и пробелы, не может начинаться или заканчиваться пробелом",
  "t-event-is-planned": "планируется",
  "t-required-action": "Операция является обязательным полем",
  "t-search-group-by-name": "Поиск группы по имени",
  "t-search-device-by-sn": "Поиск устройства по серийному номеру",
  "t-push-event-application-version": "Приложение и версия",
  "t-old": "старый",
  "t-is-planned": "планируется",
  "t-inStalled-application": "установленное приложение",
  "t-push-event-firmware-version": "Прошивка и версия",
  "t-new-version": "новая версия",
  "t-old-version": "старый вариант",
  "t-enable-disable": "Включить/отключить",
  "t-ui-setting-list": "Список настроек UI",
  "t-select-group-or-device": "Пожалуйста, выберите группу, содержащую устройство, или само устройство",
  "t-select-application-to-install": "Пожалуйста, выберите версию приложения для установки",
  "t-select-fireware-to-install": "Пожалуйста, выберите версию прошивки для установки",
  "t-select-application-to-uninstall": "Пожалуйста, выберите приложение для удаления",
  "t-select-ui-setting": "Пожалуйста, выберите настройки UI",
  "t-push-event-created-successfully": "Событие push {param} успешно создано",
  "t-error-created-push-event": "Произошла ошибка при создании события push",
  "t-execution-time-greater-than-current-time": "Время выполнения должно быть больше текущего времени",
  "t-push-event-updated-successfully": "Пуш-ивент {param} успешно обновлен",
  "t-import-device-information-details": "Детали информации о импортируемом устройстве",
  "t-import-customer-information-details": "Детали информации о клиентах для импорта",
  "t-import-partner-information-details": "Детали информации о партнере для импорта",
  "t-import-manufacturer-information-details": "Детали информации о импортируемом производителе",
  "t-import-merchant-information-details": "Детали информации о импорте торговца",
  "t-import-store-information-details": "Детали информации о импорте магазина",
  "t-import-key-information-details": "Детали информации о импорте ключа",
  "t-import-cortex-scanner-information-details": "Детали информации о импорте Cortex Scanner",
  "t-push-key-empty-error": "В группе нет устройства, соответствующего этому ключу",
  "t-total-number": "общее число",
  "t-select-tid-to-use": "Пожалуйста, выберите TID для использования",
  "t-import-failed": "Не удалось импортировать ",
  "t-network-gateway-timeout": "Время ожидания сетевого шлюза истекло. Пожалуйста, повторите попытку!",
  "t-network-service-unavailable": "Ведутся технические работы. Просим повторить попытку позже!",
  "t-network-bad-gateway": "Неверный запрос. Пожалуйста, повторите попытку!",
  "t-network-not-found": "Ресурс не найден. Пожалуйста, свяжитесь с администратором!",
  "t-network-forbidden": "Нет прав доступа, доступ запрещен!",
  "t-network-bad-request": "Ошибка тела запроса. Повторите попытку!",
  "t-network-method-not-allowed": "Метод не допускается. Пожалуйста, повторите попытку!",
  "t-spring-configuration": "Конфигурация Spring",
  "t-prefix": "префикс",
  "t-properties": "атрибут",
  "t-done": "выполнено",
  "t-property": "свойство",
  "t-git-branch": "git-ветка",
  "t-git-version": "версия git",
  "t-zone": "часовой пояс",
  "t-management-port": "Порт управления",
  "t-git-commit": "git коммит",
  "t-health-checks": "здоровье.проверки",
  "t-service-name": "Название услуги",
  "t-otp-mobile-installation-manual": "Руководство по установке мобильного токена",
  "t-otp-mobile-installation-manual-android": "《Установочное руководство мобильного токена (Android) 》",
  "t-installation-manual-android-1": "1. Войдите на рынок Google, найдите 'OTP Mobile', скачайте и установите на свой телефон",
  "t-installation-manual-android-2": "2. При первом открытии приложения otp mobile вам потребуется разрешить ряд прав, чтобы избежать проблем при использовании. Рекомендуется пользователям разрешить эти права",
  "t-installation-manual-android-3": "3. Используйте функцию «Сканирование», чтобы отсканировать информацию о QR-коде в электронном письме для активации токена",
  "t-installation-manual-android-4": "4. После успешной активации на экране приложения будет отображаться значение OTP",
  "t-installation-manual-android-5": "5. При входе в систему обычным пользователем, если для партнера, к которому он относится, включена двухфакторная аутентификация, то для входа потребуется ввести пароль.",
  "t-otp-mobile-installation-manual-ios": "Инструкция по установке мобильного токена (IOS)",
  "t-installation-manual-ios-1": "1. Войдите в App Store, найдите 'otp mobile token', скачайте и установите на свой телефон",
  "t-installation-manual-ios-2": "2. Откройте приложение otp mobile",
  "t-installation-manual-ios-3": "3. Используйте функцию «Сканирование», чтобы отсканировать информацию о QR-коде в электронном письме для активации токена",
  "t-installation-manual-ios-4": "4. После успешной активации на экране приложения будет отображаться значение OTP",
  "t-installation-manual-ios-5": "5. При входе обычного пользователя, если для партнера, к которому он относится, включена двухфакторная аутентификация, то для входа потребуется ввести пароль.",
  "t-password-configuration": "Конфигурация пароля",
  "t-passeord-use-least-one-uppercase-letter": "По крайней мере, используйте одну заглавную букву",
  "t-not-allows-use-special-characters": "Не допускается использование специальных символов",
  "t-not-allows-use-chinese-special-characters": "Не допускается использование специальных символов китайского языка",
  "t-default-template": "по умолчанию шаблон",
  "t-user-changed-to-partner": "Роль изменена на партнера: {param}",
  "t-smart-terminal-operations-remote-manager": "Удаленный менеджер операций интеллектуального терминала",
  "t-account-profile": "Профиль учетной записи",
  "t-sign-out": "выход",
  "t-merchant-portal": "Портал торговца",
  "t-storm": "STORM",
  "t-init-key": "Инициализационный ключ",
  "t-password-does-not-match": "Пароль не соответствует",
  "t-password-changed": "Пароль был изменен. Пожалуйста, войдите в систему.",
  "t-selectd-devices": "Выбранные устройства",
  "t-store-not-associated": "Магазин не связан",
  "t-push-group": "группа",
  "t-error-loading-group-device": "Произошла ошибка при загрузке устройства в группе",
  "t-reset-password-link-invalid": "Не удалось изменить пароль: эта ссылка недействительна",
  "t-changed-password": "Изменить пароль",
  "t-continue": "продолжать",
  "t-invalid-credentials": "Неверные учетные данные",
  "t-storm-version-release-notes": "Примечания о выпуске STORMV1.3.3",
  "t-version-notes-content": "В этой версии выпуска мы сосредоточились на модуле отчетов, фиксированные отчеты предоставят вам общий вид данных из разных модулей",
  "t-version-notes-one-title": "--Управление отчетами: статические отчеты",
  "t-version-notes-one-content": "STORM теперь предоставляет вам эту функцию генерации отчетов. STORM может генерировать различные форматы отчетов с разных точек зрения: оборудование, приложения, прошивку, рассылку и жизненный цикл. Также поддерживаются форматы отчетов в форматах PDF и Excel",
  "t-version-notes-two-title": "--Состояние сети устройства",
  "t-version-notes-two-content": "Сейчас мы предлагаем различные цвета для обозначения состояния разных устройств, чтобы пользователи могли быстрее понять текущее состояние сети устройства",
  "t-version-notes-two-content-green": "Зеленый: онлайн",
  "t-version-notes-two-content-red": "Красный: офлайн",
  "t-version-notes-two-content-orange": "Оранжевый: Выход за пределы геозоны",
  "t-version-notes-two-content-blue": "Синий: ожидает активации",
  "t-version-notes-two-content-grey": "Серый: не активирован",
  "t-version-notes-three-title": "--Отчет о рассылке",
  "t-version-notes-three-content": "STORM предлагает очевидный способ отображения статуса отправки. Независимо от того, успешна ли отправка, неудачна или находится в процессе, пользователи могут сразу увидеть статус по определенному цвету и цифре. Кроме того, пользователи могут отменить отправку в более раннем случае, что означает, что запрос еще не был отправлен на устройство.",
  "t-version-optimisaziton-points": "Точки оптимизации:",
  "t-version-optimisaziton-points-one-title": "--Обновление выбора партнера",
  "t-version-optimisaziton-points-one-content": "Раньше мы предоставляли только один способ поиска названия партнера, а сейчас мы предлагаем два способа - выбор и поисковую строку, чтобы соответствовать различным точкам зрения пользователей",
  "t-version-optimisaziton-points-two-title": "--Отчет об экспорте устройства Excel",
  "t-version-optimisaziton-points-two-content": "В Excel есть более подробная информация о конкретном оборудовании, поэтому пользователи могут получить больше информации всего в одном Excel",
  "t-version-optimisaziton-points-three-title": "--Уведомления от приложения",
  "t-version-optimisaziton-points-three-content": "При отправке приложения на группу устройств, если одно или несколько устройств не связаны с уровнем клиента, появится уведомление",
  "t-certificate-file": "сертификатный файл",
  "t-select-certificate-file": "Выбрать файл сертификата",
  "t-cannot-empty-existing-imei": "Невозможно очистить существующий IMEI",
  "t-required-payment-certificate-name": "Название TLS-сертификата является обязательным",
  "t-payment-certificate-saved-successfully": "TLS сертификат сохранен успешно",
  "t-payment-certificate-deleted-successfully": "TLS сертификат {param} успешно удален!",
  "t-error-deleting-payment-certificate": "Произошла ошибка при удалении TLS-сертификата",
  "t-select-start-end-time-limit": "Проверьте, чтобы временной интервал не превышал трех месяцев",
  "t-select-multiple-options": "Пожалуйста, выберите хотя бы одно условие фильтрации",
  "t-warning-to-delete-payments": "Вы уверены, что хотите удалить сертификат TLS - {param}?",
  "t-delete-device-payments": "Удалить подтверждение TLS-сертификата",
  "t-enable_tid": "Редактировать TID",
  "t-key-expired": "Ключ истек. Пожалуйста, создайте новый ключ, чтобы избежать повторения индекса ключа",
  "t-sub-partner": "подпартнер",
  "t-open-enable-otp": "Администратор включил OTP",
  "t-otp-identification-code": "Токен идентификационного кода",
  "t-token-identification-code-setting": "(Приложение мобильного токена -> Настройки -> О программе)",
  "t-required-identification-code": "Токен идентификационного кода является обязательным",
  "t-enter-otp-code": "Введите код аутентификации токена",
  "t-generate-qr-code": "генерировать QR-код",
  "t-otp-code-to-active": "Введите код OTP для активации:",
  "t-enter-otp-code-to-active": "Введите код OTP для активации",
  "t-generated-code": "Код генерации",
  "t-enter-generated-code-to-active": "Введите код активации",
  "t-required-otp-code": "Код OTP обязателен",
  "t-identification-code-criteria": "OTP-идентификационный код состоит из цифр",
  "t-otp-code-criteria": "OTP-код состоит из цифр",
  "t-please-generate-qr-code": "Просим сначала получить QR-код",
  "t-enable-update-token": "Заменяющий токен",
  "t-active-otp-success": "Активация OTP успешна!",
  "t-error-enter-minlength-identification-code": "Длина кода идентификации токена не может быть меньше 20",
  "t-bind-token-sn": "Пользователь уже связал токен (номер токена: ",
  "t-activation-otp": "Активация OTP",
  "t-activation-otp-link-invalid": "Активация OTP не удалась: эта ссылка недействительна",
  "t-generate-qr-code-failed": "Не удалось сгенерировать QR-код",
  "t-activation-otp-failed": "Активация OTP не удалась",
  "t-error-reset-password": "Не удалось сбросить пароль",
  "t-error-download-repeat": "Файл уже загружен. Просим не повторять загрузку",
  "t-profile-application-layout": "Если вы включили функцию подписи приложения (что означает, что вы загрузили сертификат приложения), убедитесь, что ваше устройство привязано к конкретному клиенту!",
  "t-export-to-json": "Экспорт в файл JSON",
  "t-device-status": "состояние устройства",
  "t-health ": " здоровье ",
  "t-versions": "версии",
  "t-search-application": "приложение",
  "t-tls-certificate-import": "Импорт сертификата TLS",
  "t-tls-certificate-bulk-upload": "Массовая загрузка сертификатов TLS",
  "t-import-tls-certificate": "Импорт сертификата TLS",
  "t-import-tls-certificate-information-details": "Детали информации о импорте TLS-сертификата",
  "t-tls-file-name": "Имя файла: {param}",
  "t-push-confirm": "Подтверждение отправки",
  "t-install-cer": "установить.cer",
  "t-push-confirm-desc": "Просим подтвердить, что вы хотите отправить все сертификаты на устройства, содержащиеся в архивном файле.",
  "t-tls-certificate": "TLS-сертификат",
  "t-add-event": "Добавить событие",
  "t-modified-date": "Дата изменения",
  "t-main-log": "Главный журнал",
  "t-bluetooth": "Блютуз",
  "t-kernel-log": "Ядро журнала",
  "t-security-processor-log": "Журнал безопасности процессора",
  "t-pos-server-log": "Лог сервера POS",
  "t-log-seconds": "секунда",
  "t-log-mins": "минут",
  "t-log-hour": "час",
  "t-log-hours": "часы",
  "t-previous": "Предыдущая страница",
  "t-today": "hoy",
  "t-month-view": "Месячный вид",
  "t-week-view": "Вид на неделю",
  "t-day-view": "Дневной вид",
  "t-message-version": "Версия сообщения",
  "t-search-firmware-version": "Версия прошивки",
  "t-capturen-not-start": "Захват не начался",
  "t-capture-completed": "Завершено захват",
  "t-capture-failed": "Не удалось захватить",
  "t-capturing": "захват в процессе",
  "t-modelversion": "Модельная версия",
  "t-firmwareversion": "Версия прошивки",
  "t-applicationversion": "версия приложения",
  "t-keymanagement": "Управление ключами",
  "t-message-management": "Управление сообщениями",
  "t-pushmanagement": "Управление рассылками",
  "t-importmanagement": "импортное управление",
  "t-logmanagement": "Журнальное управление",
  "t-ui-mgmt": "Управление UI",
  "t-roles---permissions": "роли - права доступа",
  "t-certificate-mgmt": "Управление сертификатами",
  "t-application-certificate": "сертификат приложения",
  "t-under_activation": "подлежит активации",
  "t-block~disable": "БЛОК~ДИСАБЛИРОВАТЬ",
  "t-disable~block": "DISABLE~BLOCK",
  "t-kiosk-mode-activated": "Активирован режим полноэкранного отображения",
  "t-install-app": "установить приложение",
  "t-firmware-incremental-upgrade": "Инкрементное обновление прошивки",
  "t-firmware-full-package": "Прошивка для обновления",
  "t-restart-device": "Перезапустить устройство",
  "t-storm-factory-reset-device": "Восстановление заводских настроек устройства - STORM",
  "t-device-factory-reset-device": "Восстановление заводских настроек устройства - Device",
  "t-unlock-device": "Разблокировать устройство",
  "t-planner ": " план ",
  "t-device-initialization": "устройство.инициализация",
  "t-start-log-capture": "начать захват журнала",
  "t-stop-log-capture": "остановить захват журнала",
  "t-erase-tamper": "Отменить демонтаж",
  "t-payment-application-certificate": "сертификат платежного приложения",
  "t-automatic-active": "автоматическая активация",
  "t-device-automatic-initialization": "Автоматическая инициализация устройства",
  "t-transaction-parameter": "Параметр транзакции",
  "t-not-yet-executed": "еще не выполнено",
  "t-application---full-package": "Приложение - полный пакет",
  "t-application---batch-update": "Приложение - пакет обновления пакетным способом",
  "t-factory-reset-device---storm": "Восстановление заводских настроек устройства - STORM",
  "t-factory-reset-device---device": "Восстановление заводских настроек устройства - УСТРОЙСТВО",
  "t-please-improve-tid": "Просим улучшить tid",
  "t-please-clear-tid-bind": "Просим очистить все TID, связанные с серийным номером",
  "t-profile-application-fail-cause": "Причина сбоя приложения",
  "t-profile-uisettings-fail-cause": "Причина неудачи настроек UI",
  "t-profile-systemparam-fail-cause": "Причина неудачи системного параметра",
  "t-profile-application-name": "Название приложения",
  "t-profile-application-version-name": "Название версии приложения",
  "t-profile-fail-cause": "Причина неудачи",
  "t-profile-uisettings-name": "Название настроек UI",
  "t-profile-uisettings-version-name": "Название версии настроек UI",
  "t-profile-systemparam-name": "Название системного параметра",
  "t-profile-systemparam-version-name": "Название версии системного параметра",
  "t-profile-systemparam-version": "Версия системного параметра",
  "t-error-geo-fence-action-list": "Список действий не может быть пустым",
  "t-error-geo-fence-region-list": "Список зон не может быть пустым",
  "t-error-geo-fence-action": "Действие не может быть пустым",
  "t-maximize ": "максимализировать ",
  "t-dashboard-widget-selection": "Выбор виджета панели управления",
  "t-ui-management-version": "Версия управления UI",
  "t-system-params-version": "Версия системных параметров",
  "t-action-create": "создать",
  "t-action-update": "обновление",
  "t-action-delete": "удалить",
  "t-add-region": "Добавить область",
  "t-password-configuration-select": "По крайней мере, выберите одну политику пароля",
  "t-network-try-again": "Сетевая ошибка. Пожалуйста, повторите попытку",
  "t-connection-time-out": "Соединение превысило время ожидания. Пожалуйста, повторите попытку",
  "t-application-signed-failed": "Приложение подписано с ошибкой",
  "t-add-profile-check-application": "Убедитесь, что подписанный APK успешно обнаружен",
  "t-tid-require-valid": "Если указан TID, то необходимо указать страну и регион",
  "t-file-upload": "Файл загрузки",
  "t-application-control": "управление приложением",
  "t-remove-uninstall-block": "Удалить. Отключить установку. Блокировать",
  "t-remove-password": "Удалить пароль",
  "t-app-set-uninstall-block": "Приложение настроено запретить удаление",
  "t-app-remove-uninstall-block": "Приложение удалить запрет на удаление",
  "t-app-set-password": "Пароль для настройки приложения",
  "t-app-remove-password": "Пароль для удаления приложения",
  "t-configuration-success": "Настройки приложения отправлены на устройство",
  "t-error-enter-minlength-password": "Длина пароля не может быть меньше 6",
  "t-error-enter-password": "Пароль является обязательным полем",
  "t-warning-to-remove-uninstall-block": "Вы уверены, что хотите удалить запрет на удаление приложения?",
  "t-warning-to-logout": "Вы уверены, что хотите отменить?",
  "t-email-name-required": "Имя электронной почты является обязательным полем",
  "t-email-created-successfully": "Почтовая конфигурация {param} создана успешно!",
  "t-email-updated-successfully": "Конфигурация электронной почты {param} успешно обновлена!",
  "t-error-creating-email": "Произошла ошибка при создании конфигурации электронной почты",
  "t-error-updating-email": "Произошла ошибка при обновлении конфигурации электронной почты",
  "t-enable-email-success": "Почтовая конфигурация успешно активирована",
  "t-enable-email-close": "Конфигурация электронной почты успешно отключена",
  "t-enable-email-fail": "Не удалось включить настройку электронной почты",
  "t-delete-email-error": "Конфигурация электронной почты включена, удалить нельзя!",
  "t-search-email": "электронная почта",
  "t-warning-delete-email": "Вы уверены, что хотите удалить конфигурацию электронной почты - {param}?",
  "t-delete-email-confirmation": "Подтверждение удаления конфигурации электронной почты",
  "t-email-deleted": "Конфигурация электронной почты успешно удалена!",
  "t-add-email": "Добавить электронную почту",
  "t-edit-email": "редактировать электронную почту",
  "t-enter-email-name": "Введите имя электронной почты",
  "t-enter-email-server": "Введите сервер электронной почты",
  "t-enter-port": "Входной порт",
  "t-enter-email-account": "Введите адрес электронной почты",
  "t-enter-email-sender": "Введите отправителя электронной почты",
  "t-required-email-sender": "Отправитель электронной почты обязателен",
  "t-error-email-name-pattern": "Имя электронной почты состоит из букв, цифр, подчеркивания, точек и пробелов и не может начинаться или заканчиваться пробелом",
  "t-error-email-server-required": "Электронная почта сервера обязательна",
  "t-error-email-account-required": "Электронная почта является обязательным полем для учетной записи",
  "t-error-email-port-required": "Порт является обязательным полем",
  "t-error-email-port-pattern": "Порт должен быть в диапазоне от 1 до 65535",
  "t-error-email-host-pattern": "Введите допустимый почтовый сервер",
  "t-search-key": "ключ",
  "t-search-push-detail": "Подробная информация о поисковом push-уведомлении",
  "t-search-push-event": "событие поискового уведомления",
  "t-search-log-capture-event": "Поисковый журнал",
  "t-search-partner-setting": "Партнер",
  "t-search-ui-settings-version": "Версия настроек интерфейса поиска",
  "t-search-payment-application-certificate": "TLS сертификат",
  "t-search-message-sidebar": "Поиск партнера",
  "t-email-setting-connection-success": "Успешное соединение настроек электронной почты",
  "t-email-setting-connection-failed": "Не удалось подключиться к настройкам электронной почты",
  "t-lat-and-lng": "Долгота и широта",
  "t-version-low-to-upgrade": "Текущая версия слишком низкая и не поддерживает эту функцию. Просим обновить версию",
  "t-email-settings-enable-ssl": "Включить SSL",
  "t-email-settings-enable-starttls": "Включить STARTTLS",
  "t-email-settings-meanwhile-enbale": "Невозможно одновременно включить протокол SSL и протокол TLS",
  "t-error-update-application": "Не удалось обновить приложение",
  "t-file-size-bigger": "Размер файла слишком большой",
  "t-error-bind-device": "Не удалось привязать устройство",
  "t-error-unbind-device": "Не удалось отвязать устройство ",
  "t-required-transaction-param-version-name": "Название версии параметра транзакции является обязательным",
  "t-required-package-name": "Название пакета обязательно",
  "t-required-intent-name": "Название намерения является обязательным полем",
  "t-upload-file": "загрузить файл",
  "t-deleted": "удалено",
  "t-customer-name": "название клиента",
  "t-store-name": "название магазина",
  "t-expired-at": "срок истечения",
  "t-hsm-model-name": "Название модели Hsm",
  "t-pushes": "продвигает",
  "t-is-batch-upload": "массовая загрузка",
  "t-system-param-name": "Название системного параметра",
  "t-model-type": "тип модели",
  "t-model-type-required": "Тип оборудования является обязательным полем",
  "t-smart-pos": "Интеллектуальный POS",
  "t-id-pos": "ID POS",
  "t-mpos": "MPOS",
  "t-folder-name": "имя папки",
  "t-batch-devices-details": "Подробная информация о массовом связывании/отвязке устройств",
  "t-execute-date": "Дата исполнения",
  "t-expired-date": "срок истечения",
  "t-empty-device-password": "В настоящее время на данном устройстве не установлен парольный замок",
  "t-pubkey-is-normal-no-need-to-sync": "Публичный ключ в норме, синхронизация не требуется",
  "t-task-scheduler-name": "Название системной задачи по расписанию",
  "t-add-task-scheduler": "Добавить планировщик задач системы",
  "t-edit-task-scheduler": "Редактировать планировщик задач системы",
  "t-delete-task-scheduler": "Удалить планировщик задач системы",
  "t-warning-delete-task-scheduler": "Вы уверены, что хотите удалить системную задачу по расписанию - {param}?",
  "t-task-scheduler-deleted": "Система планировщика задач {param} успешно удалена!",
  "t-error-deleting-task-scheduler": "Произошла ошибка при удалении системной задачи планировщика задач",
  "t-second": "секунда",
  "t-cycle-by": "цикл",
  "t-not-specified": "не указано",
  "t-follow": "следовать",
  "t-this-month": "этот месяц",
  "t-this-week": "на этой неделе",
  "t-specified": "указанный",
  "t-last-five-runs": "Последние пять запусков",
  "t-permissible-wildcards": "допустимые wildcard",
  "t-last": "последний",
  "t-monthly": "ежемесячно",
  "t-most-recent-working-day": "Последний рабочий день",
  "t-warning-execute-task-scheduler": "Подтвердить немедленное выполнение задачи '{param}'?",
  "t-error-execute-task-scheduler": "Произошла ошибка при выполнении системной задачи по расписанию",
  "t-enable-task-scheduler-success": "Системная планировщик задач успешно включена",
  "t-enable-task-scheduler-close": "Системная планировщик задач успешно отключена",
  "t-enable-task-scheduler-fail": "Не удалось включить планировщик задач системы",
  "t-please-select-model-version": "Пожалуйста, выберите версию модели!",
  "t-path": "путь",
  "t-rom-version": "Версия ПЗУ",
  "t-k21-version": "Версия K21",
  "t-memory-total": "Общий объем памяти",
  "t-memory-available": "Доступная память",
  "t-flash-total": "Общий объем флэш-памяти",
  "t-flash-available": "Доступная флэш-память",
  "t-battery": "батарея",
  "t-model-type-exist": "Тип модели уже существует. Пожалуйста, удалите существующие данные и добавьте заново",
  "t-model-functions": "Модель. Функции",
  "t-error-enter-valid-cleancondition": "Условие очистки может содержать только цифры",
  "t-cleancondition": "Условие очистки",
  "t-set-version-type": "Тип версии установки",
  "t-not-support-log-capture": "Традиционные терминалы не поддерживают ручное захват журналов",
  "t-example": "пример",
  "t-type-of-30-second": "Тип 1 означает 30 секунд",
  "t-type-of-60-second": "Тип 2 означает 60 секунд",
  "t-example-of-capture": "{\"fileName\":\"11.txt\",\"path\":\"\",\"type\":\"\"}",
  "t-push-scheduled-tasks": "Записи о запланированных задачах на отправку",
  "t-executing": "выполняется",
  "t-task-created": "Задача создана",
  "t-search-push-scheduled-tasks": "Записи о запланированных задачах поискового толчка",
  "t-res[i]-name": "Вы уверены, что хотите отменить задачу планирования рассылки? ",
  "t-push-scheduled-tasks-abort-successfully": "Отмена запланированной задачи на отправку выполнена успешно!",
  "t-error-push-scheduled-tasks-abort": "Произошла ошибка при отмене запланированных задач на отправку",
  "t-error-version-type-required": "Тип версии является обязательным полем",
  "t-not-support-log-capture-if-id": "Тип протокола этой аутентификационной терминала не поддерживает захват журналов",
  "t-cancel-push-success": "Отмена отправки успешна",
  "t-error-enter-maxlength-password": "Длина пароля должна быть 6 символов",
  "t-not-allow-same-duration": "Не допускается использование одинаковой продолжительности",
  "t-signature-file-currently-creating": "В настоящее время создается файл подписи...",
  "t-differential-package-creating": "Происходит создание дифференциального пакета...",
  "t-connection-type-required": "Тип соединения обязателен",
  "t-message-protocol-required": "Сообщение протокола является обязательным",
  "t-apk": "APK",
  "t-zip-dat": "ZIP|DAT",
  "t-file-type-required": "Тип файла является обязательным полем",
  "t-no-preview-available-tiff": "TIFF-файл не доступен для предварительного просмотра",
  "t-inconsistent-apk-signatures-unable-push-patch-file": "Несовместимые подписи APK. Невозможно отправить файл патча",
  "t-enter-push-event-name": "Введите название задачи планирования рассылки",
  "t-downloading": "скачивание",
  "t-batch-delete-devices": "массовое удаление устройств",
  "t-search-by-group-name": "Поиск группы по имени",
  "t-search-device-by-sn-tid-mid": "Поиск устройства по серийному номеру, TID, MID",
  "t-batch-delete-device": "удаление устройства",
  "t-batch-delete-devices-details": "Информация о массовом удалении устройств",
  "t-input-invalid-apk-password": "Пароль может содержать только цифры.",
  "t-batch-enable-disable-device": "Массовое включение и отключение устройств",
  "t-search-by-firmware": "Поиск по названию прошивки",
  "t-search-by-firmware-version": "Поиск по версии прошивки",
  "t-batch-disable-device": "массовое отключение устройств",
  "t-search-by-application": "Поиск по названию приложения",
  "t-search-by-application-version": "Поиск по названию версии приложения",
  "t-partner-mgmt": "Управление партнерами",
  "t-customer-mgmt": "Управление Клиентами",
  "t-merchant-mgmt": "Управление Торговцами",
  "t-system-general-parameter": "Общий параметр",
  "t-add-wallpaper": "добавить обои",
  "t-enter-wallpaper-name": "Введите название обоев",
  "t-wallpaper-name-required": "Название обоев является обязательным полем.",
  "t-add-boot-picture": "Добавить первую картинку при включении",
  "t-enter-boot-picture-name": "Введите имя первого кадра при включении",
  "t-boot-picture-name-required": "Имя первого кадра при включении является обязательным полем.",
  "t-add-boot-animation": "Добавить анимацию загрузки",
  "t-enter-boot-animation-name": "Введите имя анимации загрузки",
  "t-boot-animation-name-required": "Название анимации при включении является обязательным полем.",
  "t-boot-picture-file": "Файл первого кадра при включении",
  "t-boot-animation-file": "Файл анимации загрузки",
  "t-preview-wallpaper": "предварительный просмотр обоев",
  "t-preview-boot-picture": "Предварительный просмотр первого кадра загрузки",
  "t-preview-boot-animation": "Предварительный просмотр анимации загрузки",
  "t-retract": "свернуть",
  "t-expand": "развернуть",
  "t-app-mgmt": "Управление приложениями",
  "t-install-immediately-after-downloading": "Установить сразу после загрузки",
  "t-install-immediately-for-tips": "Подсказка: это может повлиять на текущую операцию клиента",
  "t-select-installation-period": "Выбрать период установки ",
  "t-automatic-upgrade-after-startup": "Автоматическое обновление после запуска",
  "t-specify-the-first-time-after-downloading": "Укажите время с первого раза после загрузки файла",
  "t-support-upgrade-strategy-for-version-code": "Стратегия обновления поддерживается для версии SMA XXX и выше.",
  "t-installation-time-greater-than-current-time": "Время установки должно быть больше текущего времени",
  "t-installation-time": "Время установки",
  "t-please-select-installation-time": "Пожалуйста, выберите первый момент после загрузки файла.",
  "t-key-mgmt": "Управление ключами",
  "t-firmware-mgmt": "Управление прошивкой",
  "t-system-settings": "Системные настройки",
  "t-search-sn-tid-mid": "SN、TID、MID、IMEI",
  "t-search-sn-mid": "SN、MID、IMEI",
  "t-search-sn-tid": "SN、TID",
  "t-search-name-mid": "NAME、MID",
  "t-search-wallpaper": "обои",
  "t-search-boot-picture": "Первый кадр при включении",
  "t-search-boot-animation": "Анимация при включении",
  "t-search-hardware-parameter": "параметры аппаратного обеспечения ",
  "t-batch-operate-device": "Операция с оборудованием партиями",
  "t-import-device": "импортируемое устройство",
  "t-apps-list": "приложения",
  "t-app-certificates": "Приложение сертификаты",
  "t-on-board-merchants": "Зарегистрированные торговцы",
  "t-device-status-tampered": "Разбор устройства",
  "t-device-status-out-of-country": "Превышение географических границ страны",
  "t-device-status-out-of-fence": "Выходит за пределы геозоны",
  "t-device-status-online": "онлайн",
  "t-device-status-offline": "оффлайн ",
  "t-device-status-disabled": "отключен",
  "t-edit-wallpaper": "редактировать обои",
  "t-edit-boot-picture": "Редактировать первую картинку при включении",
  "t-edit-boot-animation": "редактировать анимацию загрузки",
  "t-action-name": "название действия",
  "t-currencyName": "валюта",
  "t-add-hardware-parameter": "добавить параметры аппаратного обеспечения",
  "t-edit-hardware-parameter": "редактировать параметры оборудования",
  "t-add-system-general-parameter": "добавить общий параметр системы",
  "t-edit-system-general-parameter": "редактировать общие параметры системы",
  "t-error-push-search": "Пуш-Запрос",
  "t-boot-picture-version-saved-successfully": "Файл первого кадра загрузки успешно загружен",
  "t-warning-unbind-device-for-group": "Вы действительно хотите отвязать устройство - {param}?",
  "t-unbind-device-confirmation": "Подтверждение отвязки устройства",
  "t-enable-device": "Включить устройство",
  "t-warning-delete-role": "Вы уверены, что хотите удалить роль - {param}?",
  "t-confirmation-delete-role": "Подтверждение удаления роли",
  "t-select-valid-manufacturer": "Пожалуйста, выберите действительного производителя",
  "t-add-delete-device": "Добавить/удалить устройство",
  "t-add-tls-certificate": "Добавить сертификат TLS",
  "t-delete-device-information-details": "Удалить подробную информацию об устройстве",
  "t-enable-device-information-details": "Включить подробную информацию об устройстве",
  "t-disable-device-information-details": "Отключить подробную информацию об устройстве",
  "t-add-search-device": "Добавить устройство в группу",
  "t-error-enable-device": "Произошла ошибка при включении устройства",
  "t-error-disable-device": "Произошла ошибка при отключении устройства",
  "t-user-sourse": "Источник пользователя",
  "t-start-time-than-end-time-one-hour": "Время начала планирования и время окончания планирования должно быть больше тридцати минут",
  "t-enter-tid": "Введите TID",
  "t-enter-hardware-param-version-name": "Введите название параметра оборудования",
  "t-required-hardware-param-version-name": "Название параметра аппаратного обеспечения является обязательным.",
  "t-enter-system-general-param-version-name": "Введите общее название параметра системы",
  "t-required-system-general-param-version-name": "Название общего параметра системы является обязательным.",
  "t-import-failed-info": "Не удалось импортировать: ",
  "t-import-file-not-allow-special-characters": "Имя загружаемого файла не должно содержать специальных символов.",
  "t-dateYear": "год",
  "t-num": "количество",
  "t-placeholder-enter-device-secret": "Введите секрет устройства",
  "t-placeholder-enter-product-key": "Введите ключ продукта",
  "t-error-enter-device-secret": "Секрет устройства является обязательным полем.",
  "t-error-enter-product-key": "Ключ продукта является обязательным полем.",
  "t-error-product-key-pattern": "Ключ устройства допускает только ввод заглавных букв и цифр.",
  "t-warning-delete-boot-animation": "Вы уверены, что хотите удалить анимацию при включении - {param}?",
  "t-confirmation-delete-boot-animation": "Подтверждение удаления анимации загрузки",
  "t-warning-delete-boot-picture": "Вы уверены, что хотите удалить первый кадр при включении - {param}?",
  "t-confirmation-delete-boot-picture": "Подтверждение удаления первой картинки при включении",
  "t-warning-delete-wallpaper": "Вы уверены, что хотите удалить обои - {param}?",
  "t-confirmation-delete-wallpaper": "Подтверждение удаления обоев",
  "t-delete-system-general-parameter-version-confirmation": "Подтверждение удаления версии общего параметра",
  "t-warning-delete-system-general-parameter-version": "Вы уверены, что хотите удалить общую версию параметра - {param}?",
  "t-system-general-parameter-version-deleted-successfully": "Общая версия параметра {param} успешно удалена!",
  "t-error-deleting-system-general-parameter-version": "Произошла ошибка при удалении версии общего параметра системы",
  "t-system-general-parameter-version": "Версия общего параметра",
  "t-delete-hardware-parameter-version-confirmation": "Подтверждение удаления версии параметра оборудования",
  "t-warning-delete-hardware-parameter-version": "Вы уверены, что хотите удалить версию параметра оборудования - {param}?",
  "t-hardware-parameter-version-deleted-successfully": "Версия параметра оборудования {param} успешно удалена!",
  "t-error-deleting-hardware-parameter-version": "Произошла ошибка при удалении версии параметра оборудования",
  "t-hardware-parameter-version": "Версия аппаратного параметра",
  "t-system-general-parameter-version-created-successfully": "Общая версия параметра {param} успешно создана!",
  "t-error-creating-system-general-parameter-version": "Произошла ошибка при создании версии общего параметра системы",
  "t-error-loading-system-general-parameter-version": "Версия аппаратных параметров {param} успешно создана!",
  "t-hardware-parameter-version-created-successfully": "Версия параметра оборудования {param} создана успешно!",
  "t-error-creating-hardware-parameter-version": "Произошла ошибка при создании версии общих параметров оборудования системы.",
  "t-error-loading-hardware-parameter-version": "Произошла ошибка при создании версии параметров оборудования.",
  "t-boot-animation-saved-successfully": "Анимация загрузки {param} успешно сохранена!",
  "t-boot-picture-saved-successfully": "Первая кадр загрузки {param} успешно сохранена!",
  "t-wallpaper-saved-successfully": "Обои {param} успешно сохранены!",
  "t-boot-animation-updated-successfully": "Анимация загрузки {param} успешно обновлена!",
  "t-boot-picture-updated-successfully": "Первая кадр загрузки {param} успешно обновлена!",
  "t-wallpaper-updated-successfully": "Обои {param} успешно обновлены!",
  "t-error-updating-boot-animation": "Произошла ошибка при обновлении анимации загрузки",
  "t-error-updating-boot-picture": "Произошла ошибка при обновлении первой картинки загрузки",
  "t-error-updating-wallpaper": "Произошла ошибка при обновлении обоев",
  "t-error-creating-boot-animation": "Произошла ошибка при создании анимации загрузки",
  "t-error-creating-boot-picture": "Произошла ошибка при создании первой картинки загрузки",
  "t-error-creating-wallpaper": "Произошла ошибка при создании обоев",
  "t-error-loading-boot-animation": "Произошла ошибка при загрузке анимации загрузки системы",
  "t-error-loading-boot-picture": "Произошла ошибка при загрузке первого кадра при включении ",
  "t-error-loading-wallpaper": "Произошла ошибка при загрузке обоев",
  "t-load-more": "загрузить больше",
  "t-boot-animation-deleted-successfully": "Анимация загрузки {param} успешно удалена!",
  "t-boot-picture-deleted-successfully": "Первая кадр при включении {param} успешно удален!",
  "t-wallpaper-deleted-successfully": "Обои {param} успешно удалены!",
  "t-error-deleting-boot-animation": "Ошибка при удалении анимации загрузки",
  "t-error-deleting-boot-picture": "Произошла ошибка при удалении первой картинки загрузки",
  "t-error-deleting-wallpaper": "Произошла ошибка при удалении обоев",
  "t-recover-tamper-from-device": "Вы уверены, что хотите снять состояние разборки устройства?",
  "t-enter-otp-from-email": "Введите OTP из электронной почты",
  "t-enter-authorization-times": "Количество вводов авторизации",
  "t-allocate-authorization-updated-successfully": "Обновление распределения авторизации {param} успешно! ",
  "t-error-allocate-authorization-updated-times": "Произошла ошибка при обновлении количества раз выделения авторизации",
  "t-list-header-updated-successfully": "Заголовок списка успешно обновлен!",
  "t-list-header": "Заголовок списка",
  "t-push-record": "Запись о рассылке",
  "t-devices-report": "Отчет о устройствах",
  "t-dynamic-report-new": "Динамическая отчетность - новая",
  "t-fixed-report-new": "Статическая отчетность - новая",
  "t-functional-module": "функциональный модуль",
  "t-updated-successfully": "Обновлено успешно!",
  "t-required-report-name": "Название отчета является обязательным полем.",
  "t-required-report-attribute-name": "Название атрибута является обязательным.",
  "t-required-report-language": "Тип языка является обязательным полем.",
  "t-deleted-successfully": "Удалено успешно!",
  "t-push-name": "Название рассылки",
  "t-reduce": "уменьшать",
  "t-increase": "увеличить",
  "t-enable-tamper-auth": "Включить проверку на вскрытие устройства",
  "t-otp": "OTP",
  "t-mfa": "Запустить MFA",
  "t-otp-password-sent-successfully": "Отправка пароля OTP прошла успешно!",
  "t-authorization-times-required": "Количество авторизаций является обязательным полем",
  "t-resend-in": "повторно отправить",
  "t-status-indicates-scheduled-task": "Этот статус означает только то, что эта запланированная задача была создана.",
  "t-update-authorization-times": "количество обновлений авторизации",
  "t-warning-delete-allocate-authorization": "Вы уверены, что хотите удалить выделенное разрешение - {param}?",
  "t-allocate-authorization-deleted-successfully": "Авторизация распределения {param} успешно удалена!",
  "t-error-deleting-allocate-authorization": "Произошла ошибка при удалении разрешения на выделение!",
  "t-please-enter-authorization-times": "Просим ввести количество авторизаций",
  "t-minimum-authorization-times": "Минимальное количество авторизаций равно 1",
  "t-maximum-authorization-times": "Максимальное количество авторизаций составляет 10000",
  "t-detamper": "Отмена демонтажа устройства",
  "t-error-loading-allocate-authorization": "Произошла ошибка при загрузке выделения авторизации",
  "t-async-download": "асинхронная загрузка",
  "t-background-audio": "фоновое аудио",
  "t-upload-folder": "загрузить папку",
  "t-upload-folder-is-empty": "Загружаемая папка пуста",
  "t-upload-folder-maximum-length": "Максимальная длина загружаемого файла не превышает 100",
  "t-upload-folder-minimum-length": "Минимальная длина загружаемой папки не менее 1",
  "t-number-of-cycles": "количество циклов",
  "t-number-of-images-play-second": "количество изображений в секунду воспроизведения",
  "t-number-of-images-limited-sheets": "Количество файлов ограничено от 1 до 100 листов",
  "t-wav": "Вав",
  "t-sheets": "лист",
  "t-number-of-5": "1-5",
  "t-customize": "настраивать по своему усмотрению",
  "t-license-information-name-required": "Имя информации о лицензии является обязательным.",
  "t-upload-license-information-file": "загрузить файл информации о лицензии",
  "t-edit-license-information": "Редактировать адрес электронной почты для уведомлений",
  "t-error-license-information-created": "Произошла ошибка при создании информации о лицензии ",
  "t-server-info": "Информация о сервере авторизации",
  "t-enable-server-authorization": "Включить авторизацию сервера",
  "t-specified-deployment-server-info": "Информация о назначенном сервере развертывания",
  "t-ip-address": "Авторизованный IP-адрес",
  "t-mac-address": "Авторизованный адрес Mac",
  "t-authorization-period": "Срок Действия",
  "t-expiration-time-authorization": "срок действия авторизации",
  "t-buffer-after-expiration": "Буфер после истечения срока действия лицензии",
  "t-server-utc": "Часовой пояс сервера",
  "t-enable-pre-expiration-alarms": "Включить предупреждения до истечения срока",
  "t-time-to-send-alarm-emails": "За сколько дней до дедлайна отправлять предупреждающие письма по электронной почте",
  "t-reminder-interval": "Период предупреждения",
  "t-licensed-nums": "Количество Лицензий",
  "t-num-of-devices": "Устройства",
  "t-num-of-keys": "Ключи",
  "t-device-tamper-times": "Количество взломов устройства",
  "t-num-of-partners": "Партнёры",
  "t-num-of-apps-installed": "Установленные приложения",
  "t-num-of-firmwares": "Прошивки",
  "t-num-of-users": "Пользователи",
  "t-num-of-merchants": "Торговцы",
  "t-num-of-transaction-params": "Параметры транзакции",
  "t-send-email-notifications": "отправлять уведомления по электронной почте",
  "t-others": "другие",
  "t-enable-ads": "рекламу",
  "t-enable-open-api": "OPEN API",
  "t-remaining": "остаток",
  "t-days": "дни",
  "t-authorization-expiration-date": "Дата истечения срока действия авторизации",
  "t-please-charge-in-time": "Пожалуйста, обновляйтесь вовремя",
  "t-the-authorization-file-has-expired": "Авторизационный файл истек",
  "t-upload-authorization-file": "Просим загрузить файл авторизации",
  "t-alarm-email": "Уведомляющий почтовый ящик",
  "t-enable-key-push": "Key",
  "t-created-successfully": "Сохранено успешно",
  "t-auth-file-parsing-failed": "Не удалось распарсить файл авторизации",
  "t-planned-push-after-auth-period": "Время выполнения запланированной задачи не должно превышать срок действия авторизации",
  "t-expired-by": "истек",
  "t-task-created-successfully": "Системная периодическая задача успешно создана!",
  "t-error-creating-task": "Произошла ошибка при создании системной задачи по расписанию",
  "t-task-updated-successfully": "Системная периодическая задача успешно обновлена!",
  "t-error-updating-task": "Произошла ошибка при обновлении задачи по расписанию системы",
  "t-player-second-cannot-exceed-total": "Количество воспроизведений в секунду не может превышать общее количество",
  "t-function-name": "Название типа бизнеса",
  "t-key-block-value": "Значение блока ключа",
  "t-enter-key-block-value": "Введите значение блока ключа",
  "t-required-key-block-value": "Значение блока ключей является обязательным",
  "t-enter-lmk-index": "Введите индекс LMK",
  "t-required-lmk-index": "Индекс LMK является обязательным",
  "t-required-currency-code": "Валюта является обязательным полем",
  "t-required-country-code": "Страна является обязательным полем",
  "t-currency ": "валюта",
  "t-terminal-action-analysis": "Генерировать код терминала",
  "t-copy-close": "копирование и закрытие",
  "t-add-tid": "Добавить TID",
  "t-update-tid": "Обновление TID",
  "t-delete-tid": "удалить TID",
  "t-server-mdm-delete-profile-error": "Профиль инициализации терминала включен, удалить невозможно!",
  "t-required-tid": "Tid является обязательным полем",
  "t-device-to-swap": "устройство для обмена",
  "t-swap": "обмен",
  "t-swap-tid": "обменять TID",
  "t-menu-start-color": "Цвет начала меню",
  "t-menu-end-color": "Цвет окончания меню",
  "t-menu-text-color": "Цвет текста меню",
  "t-partner-icon": "Знак портала партнера",
  "t-cloud-message-push-history": "История отправки облачных сообщений",
  "t-push-history": "История отправки",
  "t-expiry-unlimited": "Бессрочно",
  "t-enable-cloud-messaging": "облачное сообщение",
  "t-receipt-layout-details": "Детали макета квитанции",
  "t-receipt-type": "Тип квитанции",
  "t-layout-name": "Название макета",
  "t-receipt-layout": "Макет квитанции",
  "t-receipt-created": "создание квитанции",
  "t-receipt-updated": "Обновление квитанции",
  "t-default-layout": "По умолчанию макет",
  "t-add-new-row": "Добавить новую строку",
  "t-add-new-column": "Добавить новый столбец",
  "t-create-row": "создать строку",
  "t-update-row": "обновлять строку",
  "t-other": "другой",
  "t-full-screen": "Полный экран",
  "t-display": "отображение",
  "t-row-number": "номер строки",
  "t-text-style": "стиль текста",
  "t-text-align": "Выравнивание текста",
  "t-receipt-rows": "строки квитанции",
  "t-label": "метка",
  "t-onboard-merchant": "Зарегистрированный торговец",
  "t-feitian-iam": "платформа аутентификации Feitian",
  "t-feitian-partner": "платформа партнеров Feitian",
  "t-user-activated": "Пользователь торговца активирован",
  "t-error-user-activation": "Произошла ошибка при активации пользователя-торговца",
  "t-mobile-activated": "Мобильный телефон активирован",
  "t-kyc-completed": "KYC выполнен",
  "t-onboard-application": "Регистрация торговца",
  "t-personal": "личная информация",
  "t-mobile-number": "номер мобильного телефона",
  "t-date-of-birth": "дата рождения",
  "t-enter-date-of birth": "Введите дату рождения",
  "t-citizenship": "национальность",
  "t-company": "Информация о компании",
  "t-country-of-registration": "страна регистрации",
  "t-legal-form": "правовая форма",
  "t-company-name": "название компании",
  "t-contact-number": "Контактный номер",
  "t-contact-person": "Контактные лица",
  "t-business-sector": "Бизнес-отрасль",
  "t-business-activity": "Бизнес-активность",
  "t-registered-company-street": "улица зарегистрированной компании",
  "t-registered-company-house-number": "Регистрационный номер компании",
  "t-registered-company-city": "город зарегистрированной компании",
  "t-registered-company-zip": "Почтовый индекс зарегистрированной компании",
  "t-registered-company-country": "Страна зарегистрированной компании",
  "t-tax-country": "Страна налогообложения",
  "t-tax-id": "Номер налоговой регистрации",
  "t-bank": "Информация о банке",
  "t-account-holder-name": "Название держателя счета",
  "t-account-type": "Тип учетной записи",
  "t-account-currency": "валюта счета",
  "t-bank-name": "название банка",
  "t-account-number": "номер счета",
  "t-additional": "дополнительная информация",
  "t-intent-of-use": "намерение использования",
  "t-source-of-use": "Источник дохода",
  "t-annual-turnover-foresee": "Предполагаемый годовой оборот",
  "t-expected-average-transaction-amount": "ожидаемая средняя сумма транзакции",
  "t-online-channel": "онлайн-канал",
  "t-documents": "файлы",
  "t-bank-statement": "банковская выписка",
  "t-id-proof": "удостоверение личности",
  "t-address-proof": "адресное доказательство",
  "t-address-proof1": "Адресное доказательство 1",
  "t-alert-mgmt": "Управление уведомлениями",
  "t-alert-settings": "Настройки оповещения",
  "t-add-alert": "Добавить настройки тревоги",
  "t-edit-alert": "Редактировать настройки тревоги",
  "t-notice-name": "Название уведомления",
  "t-notice-start-time": "Время начала действия уведомления",
  "t-alert-level-info": "обычный ",
  "t-alert-level-warn": "Предупреждение",
  "t-alert-level-critical": "критический",
  "t-day-and-time": "неделя",
  "t-alert-mechanism": "механизм оповещения",
  "t-notifying-email": "почта",
  "t-add-alert-contacts-group": "Добавить группу контактов",
  "t-edit-contacts-group": "редактировать группу контактов",
  "t-search-alert-contacts-group": "Поиск названия группы контактов",
  "t-contacts-group-name": "название",
  "t-enter-contacts-group-name": "Введите название группы контактов",
  "t-error-contacts-group-name-required": "Название группы контактов обязательно",
  "t-warning-delete-contactGroup": "Вы уверены, что хотите удалить группу контактов - {param}?",
  "t-add-alert-policy": "Добавить политику оповещения",
  "t-edit-alert-policy": "редактировать политику оповещения",
  "t-search-alert-policy": "Название политики поиска",
  "t-warning-delete-policy": "Вы уверены, что хотите удалить политику - {param}?",
  "t-policy-name": "название политики",
  "t-enter-policy-name": "Введите имя политики",
  "t-error-policy-name-required": "Название политики является обязательным полем",
  "t-error-policy-rule-template-required": "Шаблон правила является обязательным полем",
  "t-add-alert-contacts-user": "Добавить контакт",
  "t-edit-contacts-user": "редактировать контакты пользователя",
  "t-search-alert-contacts-user": "Поиск имени",
  "t-attestation": "аттестация",
  "t-add-attestation": "добавление аттестации",
  "t-error-attestation-created": "Произошла ошибка при создании аттестации",
  "t-error-attestation-updated": "Произошла ошибка при обновлении аттестации",
  "t-attestation-updated-successfully": "Успешное обновление аттестации",
  "t-attestation-created-successfully": "Успешно создано аттестацию",
  "t-attestation-deleted-successfully": "Успешно удалена аттестация!",
  "t-error-deleting-attestation": "Произошла ошибка при удалении аттестации",
  "t-search-attestation": "поиск аттестации",
  "t-warning-delete-attestation": "Вы уверены, что хотите удалить аттестацию - {param}?",
  "t-error-deleting-attestation-version": "Произошла ошибка при удалении версии аттестации",
  "t-attestation-history": "история аттестации",
  "t-old-rule": "старое правило",
  "t-new-rule": "новое правило",
  "t-view": "просмотреть",
  "t-attestation-monitor": "монитор аттестации",
  "t-alert-status-info-unread": "непрочитано",
  "t-notice-default-rule": "правило",
  "t-add-rule": "Добавить шаблон правила",
  "t-edit-rule": "Шаблон правила редактирования",
  "t-search-rule": "Шаблон правила поиска",
  "t-enter-alert-rule-name": "Введите название правила",
  "t-error-alert-rule-name-required": "Название правила является обязательным полем",
  "t-error-alert-name-required": "Название тревоги является обязательным полем",
  "t-rule-template-fence-template-name": "Аларм электронного забора",
  "t-alert-rule-updated-successfully": "Шаблон правила {param} успешно обновлен!",
  "t-rule-template-tampered-template-name": "Аварийное оповещение о вскрытии оборудования",
  "t-enable-tampered-alert": "Включить предупреждение о вмешательстве",
  "t-enable-out-of-country": "Включить сигнализацию о выходе за пределы страны",
  "t-email-message": "сообщение по электронной почте ",
  "t-error-delay-time-required": "Интервал между следующими уведомлениями является обязательным полем",
  "t-error-delay-time-max": "Максимальный интервал между следующими уведомлениями:",
  "t-error-delay-time-min": "Минимальное значение интервала между следующими уведомлениями: 1",
  "t-error-alert-channel-required": "Канал уведомления является обязательным полем",
  "t-error-alert-weeks-required": "Неделя уведомления обязательна для заполнения",
  "t-add-email-alert-template": "Шаблон оповещения о добавлении электронной почты",
  "t-add-alert-alarm-template": "Добавить шаблон почтового оповещения",
  "t-update-alert-template": "Изменить шаблон почтового оповещения",
  "t-search-alert-alarm-template": "Шаблон заголовка",
  "t-please-select-the-person-to-alert": "Пожалуйста, выберите человека для оповещения",
  "t-alert-settings-created-successfully": "Установка оповещения {param} создана успешно!",
  "t-error-created-alert-settings": "Произошла ошибка при создании настроек оповещения",
  "t-alert-settings-updated-successfully": "Настройки оповещения {param} успешно изменены!",
  "t-error-update-alert-settings": "Произошла ошибка при изменении настроек оповещения",
  "t-alert-settings-deleted-successfully": "Удаление настроек оповещения {param} выполнено успешно!",
  "t-error-deleting-alert-settings": "Произошла ошибка при удалении настроек оповещения!",
  "t-contacts-user-created-successfully": "Пользователь контактов успешно создан!",
  "t-error-created-contacts-user": "Произошла ошибка при создании пользователя контактов",
  "t-contacts-user-updated-successfully": "Пользователь контактов {param} успешно изменен!",
  "t-error-update-contacts-user": "Произошла ошибка при изменении пользователя контактов",
  "t-contacts-user-deleted-successfully": "Контактный пользователь {param} успешно удален!",
  "t-error-deleting-contacts-user": "Произошла ошибка при удалении пользователя контактов!",
  "t-contacts-group-created-successfully": "Группа контактов {param} успешно создана!",
  "t-error-created-contacts-group": "Произошла ошибка при создании группы контактов",
  "t-contacts-group-updated-successfully": "Группа контактов {param} успешно обновлена!",
  "t-error-update-contacts-group": "Произошла ошибка при изменении группы контактов",
  "t-contacts-group-deleted-successfully": "Группа контактов {param} успешно удалена!",
  "t-error-deleting-contacts-group": "Произошла ошибка при удалении группы контактов!",
  "t-alerts-policy-created-successfully": "Правило оповещения {param} успешно создано!",
  "t-error-created-alerts-policy": "Произошла ошибка при создании политики оповещений",
  "t-alerts-policy-updated-successfully": "Политика оповещений {param} успешно изменена!",
  "t-error-update-alerts-policy": "Произошла ошибка при изменении политики оповещений",
  "t-alerts-policy-deleted-successfully": "Успешно удалена политика оповещения {param}!",
  "t-error-deleting-alerts-policy": "Произошла ошибка при удалении политики оповещений!",
  "t-alert-template-created-successfully": "Шаблон оповещения {param} успешно создан!",
  "t-alert-template-updated-successfully": "Шаблон оповещения {param} успешно изменен!",
  "t-error-updated-email-alert-template": "Произошла ошибка при обновлении шаблона оповещения по электронной почте",
  "t-error-created-email-alert-template": "Произошла ошибка при изменении шаблона оповещения по электронной почте",
  "t-error-alert-email-template-title-required": "Заголовок шаблона электронной почты для оповещений является обязательным",
  "t-error-alert-email-template-subject-required": "Тема шаблона оповещения по электронной почте является обязательным полем",
  "t-error-update-alert-logs": "Произошла ошибка при изменении статуса журнала оповещений",
  "t-alert-logs-updated-successfully": "Успешно изменен статус журнала оповещений",
  "t-notifier": "уведомитель",
  "t-minimum-mobile-phone-number": "Минимальное количество цифр в мобильном номере телефона - 8",
  "t-maximum-mobile-phone-number": "Максимальное количество цифр в мобильном номере телефона - 50",
  "t-phone-duplicate":"Копировать телефон",
  "t-email-duplicate":"Повторить электронную почту",
  "t-select-valid-user-or-partner": "Пожалуйста, выберите необходимый контакт",
  "t-add-sms-gateway": "Добавить SMS-шлюз",
  "t-edit-sms-gateway": "редактировать SMS-шлюз",
  "t-enable-sms-success": "Успешно включена настройка SMS",
  "t-enable-sms-close": "Успешно отключена настройка SMS",
  "t-enable-sms-fail": "Не удалось выполнить операцию со статусом SMS",
  "t-sms-deleted": "Установка SMS удалена успешно!",
  "t-error-deleting-sms-settings": "Произошла ошибка при удалении настроек SMS!",
  "t-delete-sms-error": "Настройка SMS включена, невозможно удалить!",
  "t-sms-settings-created-successfully": "Установки SMS созданы успешно!",
  "t-error-create-sms-settings": "Произошла ошибка при создании настроек SMS! ",
  "t-sms-settings-updated-successfully": "Настройки SMS успешно обновлены!",
  "t-error-updated-sms-settings": "Произошла ошибка при изменении настроек SMS",
  "t-sms-settings-accessKeySecret": "Секретный ключ доступа",
  "t-error-sms-settings-accessKeyId-required": "В настройках SMS Access Key Id является обязательным полем",
  "t-error-sms-settings-accessKeySecret-required": "В настройках SMS Access Key Secret является обязательным полем",
  "t-error-sms-settings-signName-required": "В настройках SMS имя подписи является обязательным полем",
  "t-error-silence-time-required": "Время молчания обязательно",
  "t-error-silence-time-min": "Минимальное время молчания составляет не менее 5 минут",
  "t-error-silence-time-max": "Максимальное время молчания - 1440 минут",
  "t-enable-manufacturer": "производителя",
  "t-enable-tls-certificate": "сертификат TLS",
  "t-enable-ticket": "заявку на работу",
  "t-enable-merchant-user": "зарегистрированного торговца",
  "t-enable-attestation": "аттестацию",
  "t-enable-sms": "настройки SMS",
  "t-enable-hsm": "HSM",
  "t-enable-geo-fence": "геозону",
  "t-enable-messages": "сообщения",
  "t-enable-report": "отчет",
  "t-enable-transaction-param": "Параметр Транзакции",
  "t-enable-cortex-scanner": "Сканер Cortex",
  "t-enable-system-health": "Здоровье Системы",
  "t-enable-task-scheduler": "Планировщик Задач",
  "t-enable-feitian-partner": "Партнера FeiTian",
  "t-enable-feitian-iam": "IAM FeiTian",
  "t-enable-static-report": "статический отчёт",
  "t-enable-customize-report": "отчёт компонентов",
  "t-enable-widget-report": "динамический отчёт",
  "t-enable-report-setting": "настройки отчетов",
  "t-enable-otp": "MFA",
  "t-enable-notice": "управление тревогами",
  "t-enable-tamper": "разрешение на вмешательство в устройство",
  "t-public-platform-type": "Платформа публичного облака",
  "t-use-password-length": "Диапазон длины пароля составляет от 4 до 32",
  "t-license-id": "Лицензионный идентификатор",
  "t-user-deleted-successfully": "Пользователь {param} удален успешно!",
  "t-error-deleting-user": "Произошла ошибка при удалении пользователя!",
  "t-bind-unbind": "привязка/отвязка",
  "t-device-has-been-bind-other-partner": "В списке устройств есть устройства, привязанные к другим партнерам (нажмите для загрузки)",
  "t-device-has-been-bind-other": "В списке устройств есть устройства, связанные с другими партнерами / клиентами / торговцами / магазинами",
  "tool": {
    "routerTitle": "Настройки отчетов",
    "addbtn": "Добавить категорию",
    "reportName": "Название отчета",
    "createTime": "время создания",
    "createBy": "Автор создания",
    "updateTime": "время обновления",
    "updateBy": "Обновивший",
    "reportType": "Тип отчета",
    "universal":"универсальный",
    "custom": "контрол",
    "popUp": "Вы уверены, что хотите удалить отчет - {param}?",
    "delectTool": "Удалить отчет",
    "sortAllocation": "классификационная конфигурация",
    "conditions": "условия ",
    "attributeCode": "код атрибута",
    "attributeName": "имя атрибута",
    "dataType": "тип данных",
    "enumeratedValue": "перечисляемое значение",
    "enumerationName": "название перечисления",
    "sortDigit": "сортировать цифру",
    "associatedPath": "связанный путь",
    "associationSQL": "связанный SQL",
    "chartType": "Тип диаграммы",
    "chartSQL": "SQL диаграммы",
    "internationalization": "международная интеграция",
    "languageType": "Тип языка",
    "remark": "примечание",
    "pleaseEnter": "Пожалуйста, введите",
    "pieChart": "круговая диаграмма",
    "barChart": "столбчатая диаграмма",
    "lineChart": "линейная диаграмма",
    "string": "строка",
    "time": "время",
    "timeFrame": "диапазон времени",
    "enumeration": "перечисление",
    "year": "год",
    "month": "месяц",
    "report": "отчет"
  },
  "charts": {
    "fixedReport": "статическая отчетность",
    "dynamicReport": "динамическая отчетность",
    "search": "поиск",
    "export": "экспорт ",
    "editHeader": "Редактировать заголовок списка",
    "log": {
      "routerTitle": "Записи о рассылке",
      "partner": "партнер",
      "customer": "клиент",
      "merchant": "торговец",
      "store": "магазин",
      "modelCode": "Модельная версия",
      "perform": "выполнять действие",
      "execution": "время выполнения",
      "result": "состояние",
      "resultCause": "причина",
      "push.name": "название"
    },
    "device": {
      "routerTitle": "устройство",
      "sn": "серийный номер",
      "imei": "IMEI",
      "tid": "TID",
      "signalStrength": "сеть",
      "status": "активирован",
      "activateTime": "время активации",
      "tamper": "вскрытие устройства",
      "modelVersionName": "Версия модели",
      "buildNum": "номер версии",
      "spBootloader": "SP загрузчик загрузки",
      "spFirmware": "СП-fw",
      "smaVersionCode": "Код версии SMA",
      "longitude": "долгота и широта",
      "keyName": "ключ",
      "partnerName": "Партнер",
      "customerName": "клиент",
      "merchantName": "Продавец",
      "storeName": "магазин",
      "merchantEmail": "Электронная почта торговца",
      "storeEmail": "Почтовый ящик магазина",
      "merchantPhone": "Телефон продавца",
      "storePhone": "Телефон магазина",
      "merchantAddress": "Адрес торговца",
      "storeAddress": "Адрес магазина",
      "merchantWebsite": "Веб-сайт продавца",
      "storeWebsite": "сайт магазина",
      "currency": "валюта",
      "groupName": "группа",
      "countryName": "регион",
      "lastOnlineTime": "Время последнего входа в сеть",
      "lastDataUpdatedTime": "Время последнего обновления данных",
      "lastFactorySettingTime": "Время последнего сброса к заводским настройкам",
      "mid": "mid"
    },
    "model": {
      "head": "Заголовок списка",
      "applications": "приложения (максимум 3 )"
    }
  },
  "t-api-key": "API Key",
  "t-api-secret": "API Secret",
  "t-online-status": "Статус онлайн",
  "t-api-logs": "Журналы вызовов API",
  "t-api-parameters": "Request parameters",
  "t-click-or-drag-file-upload-file": "Нажмите или перетащите файл в эту область для загрузки",
  "t-input-invalid-pattern-special-char-name":"Состоит из цифр, букв, подчеркиваний, точек, пространств и...,&,(,),-,/,@, и не может начинаться или заканчиваться пространствами.",
  "t-cancel-message": "Отменить сообщение",
  "t-cancel-ad": "Отмена Планировщика рекламы",
  "t-warning-to-cancel-message": "Вы уверены, что хотите отменить сообщение?",
  "t-warning-to-cancel-ad": "Вы уверены, что хотите отменить рекламу?",
  "t-select-device-for-operation": "Выберите устройство для массовых операций",
  "t-select-operation-for-performed": "Выберите операцию",
  "t-themes": "Тема",
  "t-theme-customizer": "Настройка темы",
  "t-layout": "макет",
  "t-choose-layout": "Выберите макет",
  "t-color-scheme": "Цветовая схема",
  "t-choose-color-scheme": "Выберите светлую или темную схему",
  "t-sidebar": "Боковая панель",
  "t-choose-sidebar-size": "Выберите размер боковой панели",
  "t-sidebar-color": "Цвет боковой панели",
  "t-choose-sidebar-color": "Выберите светлый или темный цвет боковой панели",
  "t-choose-sidebar-image": "Выберите изображение для боковой панели",
  "t-light": "Светлый",
  "t-dark": "Тёмный",
  "t-vertical": "Вертикальный",
  "t-horizontal": "Горизонтальный",
  "t-small": "Маленький",
  "t-gradient": "Градиент",
  "t-add-more-notifier-tips": "Чтобы добавить несколько контактов, используйте \",\" для их разделения",
  "t-items": "Проекты",
  "t-push.abort.successfully": "Отменить толчок успешно!",
  "t-events": "События",
  "t-event": "События",
  "t-working-time-period": "Период работы",
  "t-repetition-interval-time": "Время повторения",
  "t-means-of-notification": "Форма уведомления",
  "t-close-left-tabs": "Закрыть вкладки слева",
  "t-close-right-tabs": "Закрыть вкладки справа",
  "t-close-other-tabs": "Закрыть другие вкладки",
  "t-parameter-settings": "Настройки параметров",
  "t-transaction-mgmt": "Управление транзакциями",
  "t-restore-default": "Restore Default",
  "t-device-extend-attribute": "Расширенный атрибут устройства",
  "t-device-life-cycle": "Жизненный цикл устройства",
  "t-otp-type-ft": "OTP Mobile",
  "t-otp-type-google": "Google Authenticator",
  "t-otp-google-download-detail": "Скачать и установить",
  "t-otp-google-download-detail-2": "На вашем телефоне",
  "t-otp-install-notes": "Инструкции по установке",
  "t-otp-mobile-download": "Скачайте приложение OTP Mobile",
  "t-error-enter-otp-code": "Длина динамического пароля составляет 6 - 10 цифр!",
  "t-scan-QRCode": "Сканировать QR-код",
  "t-scan-QRCode-detail": "Откройте приложение аутентификации и используйте камеру телефона для сканирования изображения слева",
  "t-otp-google-download": "Скачайте приложение аутентификации",
  "t-google-otp-link-invalid": "Не удалось активировать аутентификатор: Ссылка недействительна",
  "t-product-model": "Модель продукта",
  "t-release-time": "Время выпуска",
  "t-wallpaper-format": "Формат обоев",
  "t-bootPicture-format": "Формат загрузочного изображения",
  "t-BootAnimation-format": "Формат загрузочной анимации",
  "t-model-version-identification": "Идентификация версии модели",
  "t-enable-device-extend-attribute": "расширенный атрибут устройства",
  "t-enable-device-life-cycle": "жизненный цикл устройства",
  "t-is-empty": "{param} Нельзя быть пустым",
  "t-error-updating-device-extend-attribute-value": "Произошла ошибка при обновлении значения расширенного атрибута устройства",
  "t-enter-attribute-value": "Введите значение расширенного атрибута",
  "t-server-attribute-type-string": "Длина значения атрибута: 0-50; Формат: буквы, цифры",
  "t-server-attribute-type-integer": "Значение атрибута должно быть в диапазоне от 0 до 65535",
  "t-server-attribute-type-boolean": "Значение атрибута должно быть логического типа. Пожалуйста, проверьте и измените",
  "t-device-extend-attribute-value-updated-successfully": "Значение расширенного атрибута устройства успешно обновлено!",
  "t-export-to-csv": "Экспорт в CSV",
  "t-tooltip-device-tid": "SN、TID",
  "t-tid-list": "TID List",
  "t-device-life-cycle-desc": "Описание жизненного цикла",
  "t-device-life-cycle-modifyTime": "Жизненный цикл ModifyTime",
  "t-fence-boundary":"Граница ограждения",
  "t-more": "Больше",
  "t-visual-range": "Открыто для",
  "t-belong-to": "Переместить к",
  "t-belong-to-application": "Переместить к приложению",
  "t-belong-to-firmware": "Переместить к прошивке",
  "t-global-visibility": "Все",
  "t-specified-range": "Авторизованная иерархия",
  "t-shared-data-already-exists": "Распределение диапазона того же уровня уже существует. Если требуются изменения, сначала удалите существующий указанный диапазон, прежде чем добавлять новый.",
  "t-belong-to-firmware-error": "Указанный диапазон не может быть пустым",
  "t-remember-password": "Подожди, я вспомнил свой пароль...",
  "t-log-in-again": "Подожди, мне нужно войти снова...",
  "t-select-device-exist-disable-device": "Выбранное устройство содержит отключенные устройства.",
  "t-select-device-exist-inactive-device": "Выбранные устройства содержат неактивированные устройства",
  "t-device-sma-version-not-support": "ОШИБКА, ВЕРСИЯ SMA УСТРОЙСТВА ОТПРАВКИ НЕ ПОДДЕРЖИВАЕТСЯ",
  "t-owner": "Owner",
  "t-operator": "Operator",
  "t-support-format": "Поддержка форматов",
  "t-support-resolution": "Поддержка резолюции",
  "t-device-life-cycle-bulk-upload": "Пакетная загрузка жизненного цикла устройства",
  "t-import-device-life-cycle-information-details": "Подробности импорта информации о жизненном цикле устройства",
  "t-have-joined-download-queue":"В процессе",
  "t-key-value-length-is-too-long":"ДЛИНА ЗНАЧЕНИЯ КЛЮЧА СЛИШКОМ ВЕЛИКА",
  "t-pad-mode":"Идентификатор шаблона пластины",
  "t-key-not-support-pad-mode-type":"Тип паяльного диска не поддерживается",
  "t-cipher-by-pubKey":"Шифрование с использованием публичного ключа",
  "t-not-export":"Не экспортировано",
  "t-exported":"Экспортировано",
  "t-key-has-been-changed":"Ключ был изменен",
  "t-marker":"Маркер",
  "t-export-device-public-key":"Экспортировать открытый ключ",
  "t-import-tid-device-tid-conflict":"Между TID устройства и TID в импортированном файле существует конфликт",
  "t-please-enter-account-password": "Пожалуйста, введите пароль вашей учетной записи",
  "t-authorization-file":"файл авторизации",
  "t-select-device-unbind": "Пожалуйста, выберите устройство для развязки",
  "t-signature-name": "Имя подписи",
  "t-select-installed-numbers": "поддерживается выбор не более трех APK-файлов",
  "t-success-process-message": "о, да, вы успешно обработали это сообщение об аварии.",
  "t-fail-process-message": "о, да, вы не смогли обработать это сообщение об аварии.",
  "t-device-apk-password-length": "Пароль должен состоять только из 6 символов.",
  "t-no-permission": "У пользователя нет доступа к системе STORM. Пожалуйста, свяжитесь с администратором.",
  "t-hsm-message-header": "Заголовок сообщения HSM",
  "t-push-device-information": "Внимание: На интерфейсе отправки отображаются только активированные устройства, кроме отправки команды активации, которая отображает только неактивированные устройства.",
  "t-delete-push-success": "Успешное удаление уведомления",
  "t-warning-to-delete-push-scheduled-tasks": "Вы уверены, что хотите удалить запланированные задачи на отправку? ",
  "t-app-uninstall-block": "Блок удаления приложений",
  "t-app-password": "Пароль приложения",
  "t-mfa-type": "Тип MFA",
  "t-only-add-up-to-10-items-events": "Добавить только до 10 событий.",
  "t-search-name-sn": "Name、SN",
  "t-search-name-version": "Name、Version",
  "t-recorded-in-audit": "Записано только в журнале аудита",
  "t-device-status-active-key-not-exist": "Открытый ключ отсутствует",
  "t-pos-server-version": "Версия POS-сервера",
  "t-transaction-param-version-json-desc": "(STORM уже автоматически интегрировал TID и MID в Json в соответствии с SN, поэтому вам не нужно устанавливать TID и MID внутри Json. Если вы все же установите TID и MID, мы будем использовать вашу версию)",
  "t-select-algorithm": "Выберите алгоритм",
  "t-direct-push-success": "Прямая отправка успешна",
  "t-app-file-upload-right-spec": "Имена файлов поддерживают только буквы, цифры, подчёркивания и английскую точку.",
  "t-range": "Диапазон",
  "t-add-more-package-name-tips": "Чтобы добавить несколько имен пакетов, используйте запятую (,) для их разделения",
  "t-authorization-has-expired-contact-administrator": "Срок действия авторизации истек, пожалуйста, свяжитесь с администратором",
  "t-confirm-modify-password": "Срок действия пароля истёк: Ваш пароль не менялся более {param} дней. Сбросьте его для продолжения.",
  "t-static-report": "Статический Отчёт",
  "t-customize-time-before-days": "Сколько дней назад вы настраивали",
  "t-report_export_successfully": "Экспорт успешно. Пожалуйста, перейдите в \"Загрузка отчета\" для загрузки",
  "t-report-type": "Тип отчета",
  "t-chart-type": "Тип диаграммы",
  "t-confirm-stop": "Вы уверены, что хотите остановить этот рекорд?",
  "t-enter-maximum-package": "Введите максимум 3 имени пакета, разделенных запятыми",
  "t-log-capture-stop": "Захват остановился",
  "t-generate": "Сгенерировать",
  "t-schedule": "Запланировать",
  "t-data-scope": "Объем данных",
  "t-report-data-range": "Диапазон данных отчета",
  "t-table-head": "Заголовок таблицы",
  "t-visual-widget": "Визуальный Виджет",
  "t-custom-report": "Пользовательский Отчёт",
  "t-generate-schedule": "Создать расписание",
  "t-authorized-list": "Авторизованный Список",
  "t-pushed": "Отправлено",
  "t-search-criteria": "Критерии поиска",
  "t-days-range": "Диапазон дней",
  "t-maximum-json-length": "Максимальная поддерживаемая длина JSON составляет 32 000 символов",
  "t-push-status-same-file-exist": "Неудача, существует один и тот же файл",
  "t-push-status": "Push Status",
  "t-app": "Приложение",
  "t-only-show-groups-with-available-devices": "Показывать только группы с доступными устройствами",
  "t-only-show-available-devices": "Показывать только группы с доступными устройствами",
  "t-licensed-features": "Лицензированные Функции",
  "t-period": "Период",
  "t-device-is-disabled-status": "Устройство отключено, пожалуйста, включите его",
  "t-send-type": "Тип отправки",
  "t-smtp": "SMTP",
  "t-sendgrid": "SendGrid",
  "t-key-capture-device-encrypted-key-not-exist": "Ключ шифрования устройства не существует",
  "t-select-device": "Выберите устройство",
  "t-all-device": "Все устройства",
  "t-select-all-device-note": "Примечание: Прием нажатий клавиш будет выполнен на всех устройствах в указанном диапазоне, которые находятся в активном состоянии и работают нормально.",
  "t-successful-push-tasks": "Задачи Push успешные",
  "t-all-push-tasks": "Все задачи Push"
}
